  // i18n.js
  import i18n from 'i18next';
  import { initReactI18next } from 'react-i18next';
  import LanguageDetector from 'i18next-browser-languagedetector';

  // Ressources de traduction - UNIQUEMENT pour App.js
  const resources = {
    en: {
      translation: {
        "rechercher": {
          "title": "Search",
          "searchPlaceholder": "Search for a product...",
          "searchPlaceholderDetailed": "Search for a product, brand, model...",
          "searchResults": "Search results",
          "allProducts": "All products",
          "filters": {
            "title": "Filters",
            "apply": "Apply",
            "reset": "Reset",
            "activeFilters": "Active filters",
            "clearAll": "Clear all",
            "location": {
              "title": "📍 Location",
              "locateMe": "Locate me",
              "locating": "Locating...",
              "currentLocation": "Use my current location",
              "permission": {
                "title": "Location Permission",
                "message": "This app needs your location to find products near you.",
                "android": "Location permission denied",
                "ios": "iOS permission error",
                "enable": "Enable location in settings"
              }
            },
            "price": {
              "title": "💰 Price",
              "min": "Min (FCFA)",
              "max": "Max (FCFA)",
              "unlimited": "Unlimited"
            },
            "condition": {
              "title": "⚡ Condition",
              "all": "All conditions",
              "new": "New",
              "likeNew": "Like new",
              "good": "Good condition",
              "fair": "Fair condition",
              "poor": "Poor condition",
              "forParts": "For parts only"
            },
            "country": {
              "title": "🌍 Country",
              "searchPlaceholder": "Search for a country...",
              "noResults": "No country found"
            },
            "city": {
              "title": "🏙️ City",
              "searchPlaceholder": "Search for a city..."
            }
          },
          "results": {
            "found": "{{count}} product found",
            "found_plural": "{{count}} products found",
            "loading": "Searching...",
            "noResults": {
              "title": "No results found",
              "description": "No product matches your search",
              "modifySearch": "Modify search",
              "setAlert": "Set alert"
            },
            "end": "🎯 End of results",
            "loadingMore": "Loading..."
          },
          "alerts": {
            "title": "🔔 Create alert",
            "subtitle": "Be notified as soon as a matching product is available",
            "types": {
              "basic": {
                "name": "Basic Alert",
                "duration": "7 days",
                "features": [
                  "Email notification",
                  "1 saved search",
                  "Standard support"
                ]
              },
              "pro": {
                "name": "Pro Alert",
                "duration": "30 days",
                "features": [
                  "Email and SMS notifications",
                  "5 saved searches",
                  "Priority support",
                  "Detailed statistics"
                ]
              },
              "premium": {
                "name": "Premium Alert",
                "duration": "90 days",
                "features": [
                  "Real-time notifications",
                  "Unlimited searches",
                  "24/7 support",
                  "Advanced analytics",
                  "Custom alerts"
                ]
              }
            },
            "info": "🔔 Activate an alert to be notified as soon as a matching product is available.",
            "select": "Select",
            "selected": "Selected",
            "cancel": "Cancel",
            "continue": "Continue"
          },
          "payment": {
            "title": "💳 Payment method",
            "selectMethod": "Select your payment method",
            "total": "Total: {{amount}}",
            "methods": {
              "mobile_money": "Mobile Money",
              "mobile_money_desc": "Orange Money, MTN Mobile Money",
              "credit_card": "Credit card",
              "credit_card_desc": "Visa, Mastercard",
              "paypal": "PayPal",
              "paypal_desc": "Secure payment"
            },
            "details": {
              "title": "Payment details",
              "processing": "Processing payment...",
              "operator": "Operator",
              "phone": "Phone number",
              "cardNumber": "Card number",
              "expiry": "Expiry date",
              "cvv": "CVV",
              "pay": "Pay {{amount}}"
            },
            "confirmation": {
              "title": "Payment successful!",
              "amount": "Amount paid",
              "duration": "Duration",
              "reference": "Reference",
              "viewAlerts": "View my alerts"
            }
          },
          "errors": {
            "loading": "Loading error",
            "timeout": "Timeout",
            "server": "Server error",
            "connection": "No server connection",
            "geolocation": "Location error",
            "geocoding": "Geocoding error"
          },
          "buttons": {
            "back": "Back",
            "search": "Search",
            "filter": "Filter",
            "sort": "Sort",
            "close": "Close",
            "ok": "OK",
            "yes": "Yes",
            "no": "No"
          },
          "product": {
            "negotiable": "Neg.",
            "unknownLocation": "City, Country",
            "share": "Share",
            "contact": "Contact",
            "viewDetails": "View details"
          }
        },
        "user": "User",
        "seller": {
          "defaultName": "Seller",
          "listings": "Listings",
          "memberSince": "Member since",
          "noListings": "This seller hasn't published any listings yet",
          "allProducts": "All products ({{count}})",
          "clickForDetails": "Click on a product to view details",
          "unspecifiedAddress": "Address not specified",
          "fullName": "Full Name",
          "phone": "Phone",
          "address": "Address",
          "accountType": "Account Type",
          "professional": "Professional",
          "individual": "Individual",
          "business": "Business",
          "businessPhone": "Business Phone",
          "businessEmail": "Business Email",
          "website": "Website",
          "businessAddress": "Business Address",
          "specialties": "Specialties"
        },
        "titles": {
          "sellerProfile": "Seller Profile"
        },
        "sections": {
          "description": "Description",
          "professionalInfo": "Professional Information",
          "contactInfo": "Contact Information"
        },
        "tabs": {
          "products": "Products",
          "contact": "Contact"
        },
        "buttons": {
          "retry": "Retry",
          "login": "Log in",
          "call": "Call",
          "message": "Message"
        },
        "badges": {
          "new": "New",
          "premium": "Premium",
          "pro": "PRO"
        },
        "sellerTypes": {
          "garage": "Garage",
          "mechanic": "Mechanic"
        },
        "conditions": {
          "new": "New",
          "likeNew": "Like new",
          "used": "Used",
          "good": "Good condition",
          "excellent": "Excellent condition"
        },
        "timeAgo": {
          "hours": "{{count}}h ago",
          "days": "{{count}}d ago"
        },
        "sampleProducts": {
          "transmission": "Honda Accord Automatic Transmission",
          "condition": "Used - Excellent condition"
        },
        "whatsappMessage": "Hello, I am interested in your listings on Autocasses",
        "errors": {
          "missingUserId": "User ID missing",
          "noUserData": "No user data received",
          "invalidProductFormat": "Invalid response format for products",
          "loadingError": "Error loading data",
          "sessionExpired": "Session expired. Please log in again.",
          "unauthorized": "Access forbidden",
          "userNotFound": "User not found",
          "noConnection": "No connection to server"
        },
        "alerts": {
          "error": "Error",
          "info": "Information",
          "cannotOpenPhone": "Cannot open phone app",
          "phoneNotAvailable": "Phone number not available",
          "whatsappNotInstalled": "WhatsApp is not installed on your device",
          "cannotOpenEmail": "Cannot open email app",
          "emailNotAvailable": "Email address not available",
          "cannotOpenWebsite": "Cannot open website",
          "cannotOpenMaps": "Cannot open maps app"
        },
        "loadings": {
          "profile": "Loading profile..."
        },
        "productDetails": {
          "loading": "Loading product details...",
          "buttons": {
            "backToSearch": "Back to search",
            "share": "Share",
            "favorites": "Favorites",
            "contactSeller": "Contact seller",
            "showLess": "Show less",
            "readMore": "Read more"
          },
          "sections": {
            "specifications": "Specifications",
            "description": "Description",
            "additionalInfo": "Additional information"
          },
          "specifications": {
            "category": "Category",
            "subcategory": "Subcategory",
            "brand": "Brand",
            "location": "Location",
            "partNumber": "Part number",
            "warranty": "Warranty",
            "exchange": "Exchange accepted",
            "negotiable": "Negotiable",
            "country": "Country",
            "city": "City",
            "address": "Address",
            "warrantyMonths": "{{months}} months"
          },
          "fields": {
            "negotiable": "Negotiable",
            "exchangeAccepted": "Exchange accepted",
            "availability": "Availability"
          },
          "stock": {
            "inStock": "In stock",
            "outOfStock": "Out of stock"
          },
          "conditions": {
            "new": "New",
            "newFeminine": "New",
            "used": "Used",
            "good": "Good condition",
            "excellent": "Excellent",
            "average": "Average condition",
            "poor": "Poor condition",
            "repaired": "Repaired",
            "refurbished": "Refurbished",
            "unknown": "Unknown"
          },
          "warranty": {
            "months": "{{months}} months warranty",
            "none": "No warranty"
          },
          "defaults": {
            "productImage": "Product image",
            "unknownSeller": "Unknown seller",
            "untitled": "Untitled",
            "category": "Category {{id}}",
            "subcategory": "Subcategory {{id}}",
            "unspecifiedBrand": "Unspecified brand",
            "noDescription": "No description available.",
            "unknownCity": "Unknown city",
            "unknownRegion": "Unknown region"
          },
          "seller": {
            "defaultBio": "Seller on AutoCasse",
            "responseTime": "< 24 hours",
            "businessHours": {
              "monday": "9:00 AM - 6:00 PM",
              "tuesday": "9:00 AM - 6:00 PM",
              "wednesday": "9:00 AM - 6:00 PM",
              "thursday": "9:00 AM - 6:00 PM",
              "friday": "9:00 AM - 6:00 PM",
              "saturday": "9:00 AM - 1:00 PM",
              "sunday": "Closed"
            },
            "infoUnavailable": "Seller information not available"
          },
          "protection": {
            "title": "AutoCasse Protection",
            "secureTransactions": "Secure transactions",
            "customerSupport": "24/7 customer support",
            "fraudProtection": "Fraud protection"
          },
          "contact": {
            "whatsappUnavailable": "WhatsApp number not available. Contact the seller by phone.",
            "whatsappMessage": "Hello, I'm interested in your listing \"{{title}}\" on AutoCasses. Price: {{price}} XAF",
            "phoneUnavailable": "Phone number not available"
          },
          "share": {
            "message": "Discover this listing on AutoCasses\n\n{{title}}\nPrice: {{price}} XAF\n\nDownload the AutoCasse app: {{appLink}}"
          },
          "notifications": {
            "addedToFavorites": {
              "title": "Item added to favorites",
              "message": "the item {{title}} has been added to favorites"
            },
            "removedFromFavorites": {
              "title": "Item removed from favorites",
              "message": "the item {{title}} has been removed from favorites"
            }
          },
          "alerts": {
            "sessionExpiredTitle": "Session expired",
            "sessionExpiredMessage": "Your session has expired. Do you want to reconnect?",
            "reconnect": "Reconnect",
            "authenticationProblem": "Authentication problem",
            "retryWithoutAuth": "Do you want to retry without authentication?"
          },
          "logs": {
            "tokenExpired": "Token expired or invalid, trying without token...",
            "sellerInfoRetrieved": "Seller information retrieved: {{hasInfo}}",
            "noUserId": "No user ID in product data"
          },
          "warnings": {
            "categoryDetails": "Unable to retrieve category details:",
            "invalidSellerResponse": "Invalid response format for seller"
          }
        },
        "commonsssss": {
          "error": "Error",
          "info": "Information",
          "cancel": "Cancel",
          "retry": "Retry",
          "back": "Back",
          "later": "Later",
          "yes": "Yes",
          "no": "No"
        },
        "auctionDetails": {
          "header": {
            "title": "Auction Details"
          },
          "timer": {
            "days": "D",
            "hours": "H",
            "minutes": "M",
            "seconds": "S",
            "ended": "Auction ended"
          },
          "loading": "Loading details...",
          "noPhotos": "No photos available",
          "status": {
            "active": "Active",
            "ended": "Ended"
          },
          "uncategorized": "Uncategorized",
          "currentPrice": "Current price",
          "startingPrice": "Starting price",
          "bidStep": "Bid step: {{step}}",
          "duration": "Duration: {{hours}} hour{{plural}}",
          "tabs": {
            "description": "Description",
            "offers": "Bids",
            "questions": "Questions"
          },
          "noDescription": "No description available",
          "location": "Location",
          "condition": "Condition",
          "startDate": "Start date",
          "estimatedEnd": "Estimated end",
          "notSpecified": "Not specified",
          "notDefined": "Not defined",
          "additionalInfo": "Additional information",
          "region": "Region",
          "detailedAddress": "Detailed address",
          "landmark": "Landmark",
          "warranty": "Warranty",
          "negotiable": "Negotiable",
          "exchangePossible": "Exchange possible",
          "bidStepLabel": "Bid step",
          "seller": "Seller",
          "sellerDefault": "Seller",
          "locationNotSpecified": "Location not specified",
          "bids": {
            "noBids": "No bids at the moment",
            "beFirst": "Be the first to place a bid!",
            "user": "User {{id}}",
            "unknownDate": "Unknown date",
            "at": "at",
            "bidPlaced": "Your bid has been recorded!",
            "registrationError": "Error during registration"
          },
          "questions": {
            "askQuestion": "Ask a question",
            "questionPlaceholder": "Do you have a question about this product?",
            "charCount": "{{current}}/500 characters",
            "noQuestions": "No questions at the moment",
            "beFirst": "Be the first to ask a question!",
            "anonymous": "Anonymous",
            "seller": "Seller",
            "reply": "Reply",
            "replyPlaceholder": "Type your reply...",
            "replyError": "Unable to send reply",
            "writeQuestion": "Please write a question",
            "mustLogin": "You must be logged in to ask a question",
            "questionPublished": "Your question has been published",
            "publishError": "Unable to publish question"
          },
          "auth": {
            "required": "Login required",
            "mustLogin": "You must be logged in to place a bid.",
            "login": "Login",
            "notAuthenticated": "Not authenticated"
          },
          "makeBid": "Place a bid",
          "auctionEnded": "Auction ended",
          "contact": {
            "title": "Contact",
            "noContact": "No contact available for this seller"
          },
          "bidModal": {
            "title": "Place a bid",
            "currentPrice": "Current price",
            "yourBid": "Your bid (FCFA)",
            "bidStep": "Bid step: {{step}}",
            "bidHint": "Bid must be higher than current price",
            "submitBid": "Submit bid",
            "invalidBid": "Invalid bid",
            "enterValidAmount": "Please enter a valid amount",
            "mustBeHigher": "Your bid must be higher than {{price}}",
            "tooLow": "Bid too low",
            "minimumBid": "Minimum bid is {{price}}"
          }
        },
        "commonssss": {
          "error": "Error",
          "success": "Success",
          "cancel": "Cancel",
          "send": "Send",
          "publish": "Publish",
          "back": "Back",
          "ok": "OK",
          "yes": "Yes",
          "no": "No"
        },
        "locationInput": {
          "header": {
            "title": "📍 Location",
            "subtitle": "Where is your item located?"
          },
          "buttons": {
            "locateMe": "Locate Me"
          },
          "recent": {
            "title": "Recent"
          },
          "fields": {
            "country": "Country",
            "city": "City",
            "fullAddress": "Full Address (optional)",
            "fullAddressPlaceholder": "Number, street, postal code...",
            "fullAddressDescription": "For your personal use - not publicly displayed"
          },
          "selectors": {
            "countryPlaceholder": "Select a country",
            "cityPlaceholder": "Select a city"
          },
          "validation": {
            "title": "Complete Location",
            "text": "All required fields are filled"
          },
          "preview": {
            "title": "Location Preview",
            "subtitle": "What buyers will see",
            "info": "Only city and country will be visible. The address remains confidential."
          },
          "privacy": {
            "title": "Privacy Guaranteed",
            "tip1": "Your exact address is never shared publicly",
            "tip2": "Buyers only see city and country",
            "tip3": "Always suggest public meeting places"
          },
          "clear": {
            "title": "Clear Location",
            "message": "Do you really want to clear all location information?"
          },
          "modals": {
            "country": {
              "title": "Select a Country",
              "subtitle": "{{count}} country available"
            },
            "city": {
              "title": "Select a City",
              "subtitle": "{{country}} • {{count}} city"
            },
            "searchCountry": "Search for a country, capital...",
            "searchCity": "Search for a city...",
            "noCountries": "No country found",
            "noCities": "No city found",
            "tryOtherSearch": "Try with another search term",
            "noCitiesForCountry": "No city available for this country"
          }
        },
        "commonsss": {
          "cancel": "Cancel",
          "clear": "Clear"
        },
        "pricingSection": {
          "header": {
            "title": "💰 Pricing & Conditions",
            "subtitle": "Set the price in FCFA and define sales terms"
          },
          "priceInput": {
            "label": "Selling Price (FCFA) *",
            "description": "Indicate the price in CFA Francs at which you wish to sell",
            "placeholder": "0"
          },
          "currency": "FCFA",
          "pricePreview": "Price set: {{price}}",
          "salesOptions": {
            "label": "Sales Options",
            "description": "Add flexibilities to attract more buyers"
          },
          "options": {
            "negotiable": {
              "title": "Negotiable Price",
              "description": "Accept lower price offers"
            },
            "trade": {
              "title": "Trade Accepted",
              "description": "Accept trades for other products"
            }
          },
          "preview": {
            "title": "Preview for Buyers",
            "priceLabel": "Asking Price",
            "info": "Buyers will see this price with the options you have selected"
          },
          "badges": {
            "negotiable": "Negotiable",
            "trade": "Trade Possible"
          },
          "tips": {
            "title": "Tips for Setting Your Price",
            "compare": "Compare with similar listings on the platform",
            "negotiable": "A slightly negotiable price attracts more buyers",
            "trade": "Accept trades to expand your opportunities"
          },
          "format": {
            "priceZero": "0 FCFA",
            "price": "{{price}} FCFA"
          }
        },
        "commonss": {
          "editMode": "Edit Mode"
        },
        "createListing": {
          "header": {
            "create": "Create Listing",
            "edit": "Edit Listing"
          },
          "steps": {
            "photos": "Photos",
            "category": "Category",
            "description": "Description",
            "pricing": "Pricing",
            "location": "Location",
            "contact": "Contact",
            "preview": "Preview"
          },
          "stepDescriptions": {
            "photos": "Add product images (max 8)",
            "category": "Select category and specify details",
            "description": "Give an attractive title and describe your product",
            "pricing": "Set your price and indicate if negotiable",
            "location": "Indicate the country and city where the product is located",
            "contact": "How buyers can contact you",
            "preview": "Check all information before publishing"
          },
          "progress": {
            "step": "Step {{current}} of {{total}}",
            "percentage": "{{percent}}% Complete"
          },
          "validation": {
            "incompleteForm": "Incomplete Form",
            "fillAllFields": "Please fill in all required fields.",
            "fillRequiredFields": "Please fill in all required fields to continue",
            "mustBeLoggedIn": "You must be logged in to create a listing"
          },
          "buttons": {
            "proceedToPayment": "Proceed to Payment",
            "publishListing": "Publish Listing"
          },
          "upload": {
            "editing": "Editing in progress...",
            "sending": "Sending in progress..."
          },
          "loading": {
            "productData": "Loading product data..."
          },
          "success": {
            "title": "Success",
            "create": "Your product has been added successfully!",
            "edit": "Your product has been modified successfully!"
          },
          "delete": {
            "confirmation": "Confirmation",
            "message": "Are you sure you want to delete this product? This action is irreversible.",
            "success": "The product has been successfully deleted.",
            "error": "Unable to delete product"
          },
          "payment": {
            "title": "Payment for Listing",
            "description": "Pay to activate your listing with selected features",
            "failed": "Payment Failed",
            "tryAgain": "Payment failed. Please try again."
          },
          "description": {
            "titleLabel": "Listing Title",
            "titlePlaceholder": "ex: Toyota Camry Brake Pads - Original Parts",
            "titleDescription": "Create an attractive and descriptive title",
            "detailedDescription": "Detailed Description *",
            "descriptionPlaceholder": "Describe your item in detail...\\n\\n• Condition and age\\n• Installation requirements\\n• Compatibility details\\n• Defects or issues\\n• Reason for sale",
            "characterCount": "{{current}}/2000 characters",
            "keyFeatures": "Key Features (Optional)",
            "featurePlaceholder": "ex: OEM original part",
            "addFeature": "Add a Feature"
          },
          "existingPhotoName": "existing_photo_{{index}}.jpg",
          "photoName": "photo_{{timestamp}}_{{index}}.jpg"
        },
        "commons": {
          "ok": "OK",
          "cancel": "Cancel",
          "delete": "Delete",
          "previous": "Previous",
          "next": "Next",
          "update": "Update",
          "editMode": "Edit Mode"
        },
        "photoUpload": {
          "title": "📸 Product Photos",
          "subtitle": "Show your product from all angles",
          "limitReached": "Limit reached",
          "addPhotos": "Add photos",
          "selectPhotos": "Select or take high-quality photos",
          "maxReached": "Maximum {{max}} photos reached",
          "stats": "{{current}} of {{max}} photos",
          "editMode": "Edit Mode",
          "searchPlaceholder": "Search among photos...",
          "noPhotosFound": "No photos found",
          "allPhotos": "All Photos",
          "noPhotos": "No photos",
          "emptyState": "Add photos to show your product from all angles",
          "gallery": "Gallery",
          "camera": "Camera",
          "tips": {
            "title": "Professional Photo Tips",
            "primary": {
              "title": "Main Photo",
              "text": "Use the most attractive image as first photo"
            },
            "lighting": {
              "title": "Good Lighting",
              "text": "Photograph in daylight with natural light"
            },
            "angles": {
              "title": "Multiple Angles",
              "text": "Show product from different angles"
            },
            "transparency": {
              "title": "Transparency",
              "text": "Clearly show any defects or wear"
            }
          },
          "badges": {
            "primary": "Primary",
            "existing": "Existing"
          },
          "actions": {
            "photo": "Photo Actions",
            "setPrimary": "Set as primary",
            "moveUp": "Move up",
            "moveDown": "Move down",
            "delete": "Delete photo",
            "deleteTitle": "Delete photo",
            "deleteMessage": "Are you sure you want to delete this photo?",
            "cancel": "Cancel",
            "deleteButton": "Delete",
            "info": "Information",
            "cannotChangePrimary": "Primary photo cannot be changed in edit mode",
            "cannotReorder": "Reordering is only available for new photos"
          },
          "modals": {
            "imageInfo": "Image Information",
            "fileSize": "{{size}} MB",
            "loadingError": "Unable to load this image"
          }
        },
        "headers": {
          "navigation": "Navigation",
          "categories": "Categories",
          "loadingCategories": "Loading categories...",
          "noCategories": "No categories available",
          "retry": "Retry",
          "account": "My Account",
          "myProfile": "My Profile",
          "profileDescription": "Manage my account",
          "myFavorites": "My Favorites",
          "favoritesDescription": "Saved articles",
          "logout": "Logout",
          "subcategories": "Subcategories",
          "noSubcategories": "No subcategories available",
          "loadingSubcategories": "Loading...",
          "searchCategory": "Search category",
          "usersCount": "{{count}} users",
          "favoritesBadge": "{{count}}"
        },
        "menu": {
          "open": "Open menu",
          "close": "Close menu",
          "search": "Search",
          "viewAll": "View all"
        },
        "categories": {
          "engine": "ENGINE & COMPONENTS",
          "transmission": "TRANSMISSION",
          "brakes": "BRAKES",
          "suspension": "SUSPENSION",
          "bodywork": "BODYWORK"
        },
        "favorites": {
          "title": "My Favorites",
          "loading": "Loading your favorites...",
          "error": {
            "title": "Oops!",
            "connection": "No internet connection",
            "unauthorized": "Please log in to see your favorites",
            "forbidden": "Unauthorized access",
            "generic": "An error occurred",
            "loading": "Error loading favorites"
          },
          "empty": {
            "title": "No favorites",
            "description": "You don't have any products in your favorites yet."
          },
          "stats": {
            "count": "{{count}} product{{plural}} favorited",
            "removeAll": "Remove all favorites"
          },
          "product": {
            "condition": {
              "new": "New",
              "excellent": "Excellent",
              "good": "Good",
              "fair": "Fair",
              "poor": "Poor",
              "unknown": "Unknown condition"
            },
            "seller": "Seller",
            "location": "Location",
            "contact": "Contact",
            "share": "Share",
            "remove": "Remove from favorites",
            "viewDetails": "View details"
          },
          "actions": {
            "retry": "Retry",
            "search": "Discover products",
            "home": "Back to home",
            "clearAll": "Clear all",
            "remove": "Remove",
            "cancel": "Cancel"
          },
          "alerts": {
            "removeTitle": "Remove from favorites",
            "removeMessage": "Are you sure you want to remove this product from your favorites?",
            "clearAllTitle": "Clear all favorites",
            "clearAllMessage": "Are you sure you want to clear all your favorites?",
            "successRemove": "Product removed from favorites",
            "successClearAll": "All favorites have been removed",
            "errorRemove": "Unable to remove product from favorites",
            "errorClearAll": "Unable to clear favorites",
            "contact": "Contact seller",
            "share": "Share product"
          },
          "header": {
            "favoritesList": "Your favorite products"
          }
        },
        "verification": {
          "title": "Identity Verification",
          "subtitle": "Complete verification to build trust and unlock premium features",
          "completed": "Completed",
          "progress": "Verification Progress",
          "verificationSteps": {
            "phone": {
              "title": "Phone Verification",
              "description": "Verify your phone number via SMS"
            },
            "whatsapp": {
              "title": "WhatsApp Verification",
              "description": "Verify your WhatsApp number"
            },
            "identity": {
              "title": "Identity Document",
              "description": "Upload national ID or passport"
            },
            "photo": {
              "title": "Profile Photo",
              "description": "Upload a clear photo of yourself"
            }
          },
          "status": {
            "completed": "Completed",
            "pending": "Pending",
            "rejected": "Rejected",
            "uploading": "Uploading..."
          },
          "actions": {
            "upload": "Upload",
            "retry": "Retry"
          },
          "documents": {
            "title": "Uploaded Documents",
            "identity": "Identity Document",
            "photo": "Profile Photo",
            "status": "Status: {{status}}"
          },
          "success": {
            "title": "Verification Complete!",
            "description": "You now have access to premium features, professional seller badge, and increased buyer trust."
          },
          "benefits": {
            "premium": "Premium Features",
            "badge": "Professional Seller Badge",
            "trust": "Increased Buyer Trust"
          }
        },
        "common": {
          "cancel": "Cancel",
          "confirm": "Confirm",
          "success": "Success",
          "error": "Error",
          "currency": "FCFA",
          "hours": "hours",
          "duration": "Duration",
          "currentPrice": "Current price",
          "noTitle": "No title",
          "save": "Save",
          "edit": "Edit",
          "delete": "Delete",
          "view": "View"
        },
        "header": {
          "title": "My Products",
          "subtitle": "Manage your ads and auctions"
        },
        "stats": {
          "total": "Total",
          "active": "Active",
          "inactive": "Inactive",
          "sold": "Sold"
        },
        "search": {
          "placeholder": "Search a product...",
          "clear": "Clear search"
        },
        "filters": {
          "all": "All",
          "active": "Active",
          "auction": "Auctions",
          "sold": "Sold"
        },
        "product": {
          "status": {
            "active": "Active",
            "sold": "Sold"
          },
          "badges": {
            "sold": "Sold",
            "negotiable": "Negotiable",
            "exchange": "Exchange",
            "new": "New",
            "likeNew": "Like new"
          },
          "auction": "Auction",
          "noDescription": "No description",
          "unspecified": "Not specified",
          "unknownDate": "Unknown date"
        },
        "actions": {
          "view": "View",
          "auction": "Auction",
          "stop": "Stop",
          "markSold": "Mark sold",
          "edit": "Edit",
          "delete": "Delete",
          "addProduct": "Add product"
        },
        "auctionModal": {
          "title": "Start an auction",
          "subtitle": "Configure your auction settings",
          "productSection": {
            "title": "Selected product"
          },
          "settingsSection": {
            "title": "Auction settings"
          },
          "settings": {
            "startPrice": "Starting price",
            "startPriceDescription": "Initial auction price",
            "requiredField": "Required field",
            "minBid": "Minimum bid step",
            "minBidDescription": "Minimum increase between bids",
            "optional": "Optional - leave empty if no minimum",
            "duration": "Auction duration",
            "durationDescription": "Time during which the auction will be active",
            "customDuration": "Or custom duration",
            "customPlaceholder": "Ex: 48",
            "maxDuration": "Maximum duration: {{hours}} hours (30 days)"
          },
          "timeOptions": {
            "1day": "1 day",
            "2days": "2 days",
            "3days": "3 days",
            "1week": "1 week",
            "2weeks": "2 weeks",
            "1month": "1 month"
          },
          "validation": {
            "title": "Validation error",
            "startPrice": "Please enter a valid starting price (minimum 1 FCFA).",
            "time": "Please enter a valid time in hours (minimum 1 hour).",
            "maxTime": "Maximum duration is {{hours}} hours (30 days).",
            "minBid": "Minimum bid step must be a positive number.",
            "invalidTime": "Duration must be between 1 and {{hours}} hours.",
            "invalidPrice": "Starting price must be greater than 0.",
            "invalidMinBid": "Minimum bid step must be greater than 0."
          },
          "confirmation": {
            "title": "Confirmation",
            "message": "Confirm auction launch?\n\nDuration: {{duration}}\nStarting price: {{price}} FCFA\n{{minBid}}"
          },
          "info": {
            "title": "Important information",
            "point1": "Auction will be visible immediately after validation",
            "point2": "You will receive a notification for each new bid",
            "point3": "You can stop the auction anytime from this interface",
            "point4": "A 5% commission will be deducted from the final sale price"
          },
          "summary": {
            "title": "Auction summary",
            "startPrice": "Starting price",
            "minBid": "Minimum step"
          },
          "startAuction": "Start auction",
          "starting": "Starting..."
        },
        "auction": {
          "success": "Auction started successfully for {{time}} hour{{plural}}.",
          "error": "Unable to start auction. Please try again.",
          "invalidData": "Invalid data. Please check the information entered.",
          "productNotFound": "Product no longer exists.",
          "timeout": "Request timed out. Check your internet connection.",
          "stop": {
            "title": "Stop auction",
            "message": "Are you sure you want to stop this auction? This will immediately end all current bids.",
            "button": "Stop auction",
            "success": "Auction stopped successfully.",
            "error": "Unable to stop auction. Please try again."
          }
        },
        "delete": {
          "confirmTitle": "Confirm deletion",
          "confirmMessage": "Are you sure you want to permanently delete this product? This action is irreversible.",
          "deleteButton": "Delete",
          "success": "Product deleted successfully.",
          "error": "Unable to delete product. Please try again.",
          "notFound": "Product no longer exists.",
          "unauthorized": "You are not authorized to delete this product."
        },
        "markSold": {
          "title": "Mark as sold",
          "message": "Has this product been sold? This action will remove it from active listings.",
          "button": "Mark as sold",
          "success": "Product marked as sold.",
          "error": "Unable to mark as sold. Please try again."
        },
        "refresh": {
          "title": "Pull to refresh"
        },
        "footer": {
          "loadMore": "Load more products",
          "pageInfo": "Page {{current}} of {{total}}",
          "searchResults": "{{count}} product{{plural}} found",
          "allProducts": "All your products are displayed",
          "addNewProduct": "Add a new product"
        },
        "emptyScreen": {
          "title": "No products yet",
          "description": "Start by creating your first ad to sell your products.",
          "createFirstAd": "Create my first ad"
        },
        "emptySearch": {
          "title": "No results found",
          "description": "No product matches \"{{query}}\"",
          "clear": "Clear search"
        },
        "errorScreen": {
          "title": "Oops! An error occurred",
          "retry": "Retry",
          "back": "Back"
        },
        "Acceuil": "Home",
        "Shop": "Shop",
        "Vendre": "Sell",
        "Enchères": "Auctions",
        "Profile": "Profile",
        "profileHeader": {
          "welcome": "Hello{name} 👋",
          "personalTitle": "Manage your personal space",
          "status": {
            "pro": "Professional verified",
            "verified": "Account verified"
          },
          "proCard": {
            "title": "Go Professional",
            "description": "Increase your visibility, receive more requests and manage your activity efficiently.",
            "benefits": {
              "verified": "Verified profile",
              "visibility": "More visibility",
              "tools": "Management tools"
            }
          },
          "contact": {
            "call": "Call",
            "locate": "Locate",
            "email": "Email",
            "website": "Website"
          },
          "infoSections": {
            "about": "About",
            "specialties": "Specialties",
            "hours": "Opening hours"
          },
          "buttons": {
            "editPro": "Edit professional profile",
            "becomePro": "Become Professional",
            "save": "Save",
            "cancel": "Cancel",
            "activate": "Activate profile"
          },
          "modal": {
            "editTitle": "Edit professional profile",
            "editSubtitle": "Update your information",
            "becomeTitle": "Become Professional",
            "becomeSubtitle": "Increase your visibility",
            "activityType": "Activity Type",
            "activityDescription": "Select your main activity area",
            "basicInfo": "Basic Information",
            "presentation": "Presentation",
            "companyName": "Company name",
            "address": "Address",
            "phone": "Phone",
            "email": "Email",
            "website": "Website",
            "description": "Description",
            "descriptionPlaceholder": "Describe your company and services...",
            "specialties": "Specialties",
            "specialtiesPlaceholder": "Ex: Mechanics, Bodywork, Painting...",
            "hours": "Opening hours",
            "hoursPlaceholder": "Ex: Monday-Friday 8am-6pm, Saturday 8am-1pm",
            "infoNote": "Your changes will be immediately visible to your customers.",
            "charCount": "characters",
            "loading": "Loading..."
          },
          "validation": {
            "companyRequired": "Please enter your company name",
            "addressRequired": "Please enter your company address",
            "phoneRequired": "Please enter a professional phone number"
          },
          "messages": {
            "updateSuccess": "✓ Professional information updated",
            "activationSuccess": "🎉 Professional profile activated successfully",
            "congratulations": "Congratulations!",
            "activationMessage": "Your professional profile is now active.\nYou now have access to all pro features.",
            "super": "Great!",
            "error": "An error occurred. Please try again.",
            "updatingData": "Updating data...",
            "refreshData": "Refresh data..."
          },
          "activityTypes": {
            "Service Locations auto/moto": "Car/Motorcycle Rental Service",
            "Service Lavage auto/moto": "Car/Motorcycle Wash Service",
            "Service Auto/moto école": "Driving School Service",
            "Service Garage/mécanique": "Garage/Mechanical Service",
            "Service Visite technique": "Technical Inspection Service",
            "Service Entretien (vidange/huile)": "Maintenance Service (oil change/oil)",
            "Service Carrosserie/Peinture": "Bodywork/Painting Service",
            "Service Assurance auto/moto": "Car/Motorcycle Insurance Service",
            "Service Vente auto/moto": "Car/Motorcycle Sales Service",
            "Service Vente de pièces": "Parts Sales Service"
          },
          "defaults": {
            "autoProfessional": "Auto professional",
            "contact": "Contact",
            "about": "About"
          }
        },
        "userProfile": {
          "title": "User Profile",
          "tabs": {
            "overview": "Overview",
            "products": "Items",
            "verification": "Verification",
            "privacy": "Privacy"
          },
          "profileHeader": {
            "noLocation": "Location not specified",
            "noEmail": "Not specified",
            "stats": {
              "listings": "Listings",
              "sales": "Sales",
              "response": "Response"
            },
            "updateSuccess": "Profile updated successfully",
            "updateError": "Error updating profile"
          },
          "editModal": {
            "title": "Edit Profile",
            "profilePicture": "Profile Picture",
            "noPhoto": "No photo",
            "helpText": "Choose a photo for your profile (max 5MB)",
            "gallery": "Gallery",
            "camera": "Camera",
            "remove": "Remove",
            "personalInfo": "Personal Information",
            "fullName": "Full name *",
            "fullNamePlaceholder": "Your full name",
            "email": "Email *",
            "emailPlaceholder": "your@email.com",
            "phone": "Phone",
            "phonePlaceholder": "Your phone number",
            "address": "Address",
            "addressPlaceholder": "Your full address",
            "changePassword": "Change Password",
            "passwordNote": "Leave empty to keep current password",
            "currentPassword": "Current Password",
            "currentPasswordPlaceholder": "Current password",
            "newPassword": "New Password",
            "newPasswordPlaceholder": "New password",
            "confirmPassword": "Confirm Password",
            "confirmPasswordPlaceholder": "Confirm new password",
            "cancel": "Cancel",
            "save": "Save",
            "uploading": "Uploading...",
            "saving": "Saving..."
          },
          "validation": {
            "nameRequired": "Name is required",
            "emailRequired": "Email is required",
            "invalidEmail": "Invalid email",
            "invalidPhone": "Invalid phone number",
            "currentPasswordRequired": "Current password is required",
            "passwordMinLength": "Minimum 6 characters",
            "passwordMismatch": "Passwords do not match",
            "formErrors": "Please correct errors in the form"
          },
          "alerts": {
            "error": "Error",
            "success": "Success",
            "removePhoto": "Remove Photo",
            "removePhotoConfirm": "Do you want to remove your profile photo?",
            "cancel": "Cancel",
            "remove": "Remove",
            "imageError": "Unable to select image",
            "cameraError": "Unable to take photo",
            "uploadError": "Error uploading image",
            "invalidImage": "Invalid image format",
            "imageTooLarge": "Image is too large (max 5MB)",
            "emailInUse": "This email is already used by another account",
            "sessionExpired": "Session expired. Please log in again."
          },
          "loading": {
            "loadingProfile": "Loading your profile...",
            "refreshing": "Updating..."
          },
          "userTypes": {
            "garage": "Garage/Mechanical Service",
            "user": "User"
          },
          "status": {
            "verified": "Verified",
            "pro": "PRO"
          },
          "emptyFields": {
            "user": "User",
            "location": "Location not specified"
          }
        },
        "auctions": {
          "title": "Ongoing Auctions",
          "subtitle": {
            "active": "active",
            "active_plural": "active",
            "total": "in total"
          },
          "stats": {
            "active": "Active",
            "expiringSoon": "Expiring soon",
            "total": "Total",
            "ended": "Ended"
          },
          "auctionCard": {
            "auction": "AUCTION",
            "ended": "ENDED",
            "expired": "Terminated",
            "time": {
              "days": "d",
              "hours": "h",
              "minutes": "m",
              "seconds": "s"
            },
            "location": "Location not specified",
            "currentPrice": "CURRENT PRICE",
            "startingPrice": "STARTING PRICE",
            "placeBid": "Place bid",
            "viewDetails": "View details",
            "makeOffer": "Make offer",
            "noPhotos": "No photos"
          },
          "emptyState": {
            "title": "No auctions available",
            "message": "There are no active auctions at the moment. Come back later to discover new opportunities.",
            "refresh": "Refresh"
          },
          "loading": "Loading auctions...",
          "timeLeft": {
            "days": "days",
            "hours": "hours",
            "minutes": "minutes",
            "seconds": "seconds",
            "expired": "Expired",
            "urgent": "Ending soon",
            "endingToday": "Ending today"
          }
        },
        "shop": {
          "title": "SHOP",
          "subtitle": {
            "products": "product available",
            "products_plural": "products available"
          },
          "searchPlaceholder": "Search for a product, brand, model...",
          "quickSearch": {
            "porsche": "Porsche",
            "jeep": "Jeep",
            "new": "New",
            "auction": "Auction"
          },
          "productCard": {
            "state": "Condition",
            "auction": "Auction",
            "negotiable": "Negotiable",
            "exchange": "Exchange",
            "warranty": "Warranty",
            "viewDetails": "View details",
            "unknownLocation": "Location not specified",
            "seller": "Seller",
            "garage": "Garage",
            "mechanic": "Mechanic",
            "professional": "Professional",
            "private": "Private",
            "new": "New",
            "likeNew": "Like New",
            "used": "Used"
          },
          "emptyState": {
            "title": "No results",
            "message": "No product matches your search",
            "showAll": "Show all products",
            "alert": "Set alert",
            "alertMessage": "Activate an alert for this product for 1 month for only 500 FCFA."
          },
          "footer": {
            "allProducts": "You've seen all {count} products",
            "searchResults": "{count} product matches your search",
            "searchResults_plural": "{count} products match your search"
          },
          "loading": "Loading products...",
          "filters": {
            "all": "All",
            "new": "New",
            "used": "Used",
            "auction": "Auction",
            "negotiable": "Negotiable"
          },
          "sort": {
            "recent": "Most recent",
            "priceLow": "Price: Low to High",
            "priceHigh": "Price: High to Low",
            "distance": "Distance"
          }
        },
        "services": {
          "title": "Pro Services",
          "subtitle": "Services sorted by distance",
          "subtitleNoLocation": "Enable location to see distances",
          "activeUsers": "Active Users",
          "availableParts": "Parts Available",
          "coverage": "Coverage",
          "verifiedServices": "Verified Services",
          "searchPlaceholder": "Search for a service...",
          "allServices": "All Services",
          "centers": "Centers",
          "garages": "Garages",
          "pro": "PRO",
          "locationPermission": {
            "title": "Location Permission",
            "message": "The app needs access to your location to calculate distances.",
            "iosError": "iOS permission error",
            "androidError": "Android permission error",
            "denied": "Location permission denied",
            "unable": "Unable to get location"
          },
          "filters": {
            "nearMe": "Near me",
            "withAvailability": "With availability",
            "verifiedOnly": "Verified only",
            "openNow": "Open now"
          },
          "status": {
            "open": "Open",
            "closed": "Closed",
            "openingHours": "Opening hours",
            "waitTime": "Wait time"
          },
          "stats": {
            "usersCount": "Active professionals",
            "partsCount": "Available parts",
            "regionsCount": "Covered regions",
            "verifiedCount": "Verified services"
          },
          "serviceTypes": {
            "center": "Center",
            "garage": "Garage",
            "mechanical": "Mechanical",
            "technicalInspection": "Technical inspection"
          },
          "features": {
            "professional": "Professional",
            "certified": "Certified",
            "localService": "Local service",
            "repair": "Repair",
            "maintenance": "Maintenance",
            "parts": "Parts"
          },
          "buttons": {
            "call": "Call",
            "whatsapp": "WhatsApp",
            "details": "Details",
            "retry": "Retry",
            "refresh": "Refresh",
            "enableLocation": "Enable location"
          },
          "messages": {
            "loading": "Loading services...",
            "locationDetected": "Location detected ✓",
            "noServices": "No services available",
            "noProServices": "No PRO services available",
            "noMatch": "No service matches your criteria",
            "phoneUnavailable": "Phone number unavailable",
            "whatsappUnavailable": "WhatsApp number unavailable",
            "callService": "Call service",
            "confirmCall": "Do you want to call",
            "cancel": "Cancel",
            "call": "Call",
            "whatsappNotInstalled": "WhatsApp is not installed",
            "phoneAppError": "Unable to open phone app"
          },
          "emptyStates": {
            "noServices": "No services found at the moment",
            "noResults": "No services match your search criteria",
            "enableFilters": "Try changing your search or filters"
          },
          "distance": "km",
          "reviews": "reviews",
          "unknownCity": "Unknown city",
          "unknownAddress": "Address not specified",
          "categories": {
            "mechanical": "Mechanical",
            "inspection": "Technical inspection",
            "repair": "Repair",
            "maintenance": "Maintenance"
          }
        },
        "trustSignals": {
          "sectionTitle": "Security & Trust",
          "sectionSubtitle": "We implement everything to ensure secure and transparent transactions",
          "whyTrustUs": "Why trust us?",
          "joinCommunity": "Join our growing community of automobile enthusiasts",
          "userTestimonials": "What our users say",
          "realExperiences": "Real experiences from our community",
          "securePayments": "Secure Payments",
          "paymentOptions": "Multiple payment options adapted to Cameroon",
          "joinCommunityCTA": "Join the community",
          "createAccount": "Create your account in less than 2 minutes",
          "allTransactions": "All transactions are encrypted and secure",
          "activeUsers": "Active Users",
          "partsAvailable": "Parts Available",
          "regionsCovered": "Regions Covered",
          "averageRating": "Average Rating",
          "stats": {
            "verifiedUsers": "Verified sellers and buyers",
            "newUsedParts": "New and used",
            "countrywide": "Throughout Cameroon",
            "customerSatisfaction": "Customer satisfaction"
          },
          "securityFeatures": {
            "identityVerification": {
              "title": "Identity Verification",
              "description": "Optional validation with photo and ID document"
            },
            "fraudProtection": {
              "title": "Fraud Protection",
              "description": "Warning messages and reporting of suspicious activities"
            },
            "certifiedSellers": {
              "title": "Certified Sellers",
              "description": "Professional badges for verified sellers"
            },
            "secureCommunication": {
              "title": "Secure Communication",
              "description": "WhatsApp integration for transparent exchanges"
            }
          },
          "paymentMethods": {
            "orangeMoney": "Orange Money",
            "mtnMobileMoney": "MTN Mobile Money"
          },
          "seller": "Seller",
          "buyer": "Buyer",
          "professionalBadges": "Professional badges",
          "transparentExchanges": "Transparent exchanges"
        },
        "recentListings": {
          "sectionTitle": "Recent Listings",
          "sectionSubtitle": "Latest parts and vehicles added to the platform",
          "viewAll": "View all listings",
          "loadMore": "Load more listings",
          "new": "New",
          "negotiable": "Negotiable",
          "exchange": "Exchange",
          "loading": "Loading listings...",
          "retry": "Retry",
          "noListings": "No listings available",
          "addListing": "Add listing",
          "errorLoading": "Error loading listings",
          "justNow": "Just now",
          "minutesAgo": " min ago",
          "hoursAgo": "h ago",
          "daysAgo": "d ago",
          "conditions": {
            "new": "New",
            "likeNew": "Like new",
            "used": "Used",
            "goodCondition": "Good condition",
            "excellentCondition": "Excellent condition"
          }
        },
        "Catégories": "Categories",
        "Pièces et accessoires moto": "Motorcycle parts & accessories",
        "Motorcycle parts & accessories": "Motorcycle parts & accessories",
        "Moteurs et composants": "Engines and components",
        "Engines and components": "Engines and components",
        "Œuvres d'art uniques": "Unique artworks",
        "Unique artworks": "Unique artworks",
        "Pièces automobile complètes": "Complete auto parts",
        "Complete auto parts": "Complete auto parts",
        "Carrosserie et peinture": "Bodywork and paint",
        "Bodywork and paint": "Bodywork and paint",
        "Systèmes de freinage": "Braking systems",
        "Braking systems": "Braking systems",
        "Suspensions et amortisseurs": "Suspensions and shocks",
        "Suspensions and shocks": "Suspensions and shocks",
        "Transmissions et boîtes": "Transmissions and gearboxes",
        "Transmissions and gearboxes": "Transmissions and gearboxes",
        "Systèmes d'échappement": "Exhaust systems",
        "Exhaust systems": "Exhaust systems",
        "Produits de qualité": "Quality products",
        "Quality products": "Quality products",
        "Loading categories...": "Loading categories...",
        "Unable to load categories. Check your connection.": "Unable to load categories. Check your connection.",
        "Invalid API response format": "Invalid API response format",
        "Error fetching categories:": "Error fetching categories:",
        "Error loading language preference:": "Error loading language preference:",
        "Retry": "Retry",
        "Populaire": "Popular",
        "Popular": "Popular",
        "Pièces Moto": "Motorcycle Parts",
        "Motorcycle Parts": "Motorcycle Parts",
        "Moteurs": "Engines",
        "Engines": "Engines",
        "Carrosserie": "Bodywork",
        "Bodywork": "Bodywork",
        "Freins": "Brakes",
        "Brakes": "Brakes",
        "Accessoires et pièces détachées": "Accessories and spare parts",
        "Accessories and spare parts": "Accessories and spare parts",
        "Moteurs complets et pièces": "Complete engines and parts",
        "Complete engines and parts": "Complete engines and parts",
        "Pièces de carrosserie auto": "Auto body parts",
        "Auto body parts": "Auto body parts",
        "Note: The main category cannot be changed in edit mode.": "Note: The main category cannot be changed in edit mode.",
        "Product Category *": "Product Category *",
        "Subcategory": "Subcategory",
        "Compatible Brands (Optional)": "Compatible Brands (Optional)",
        "Vehicle Details *": "Vehicle Details *",
        "Product Condition *": "Product Condition *",
        "Additional Details (Optional)": "Additional Details (Optional)",
        "Current category (cannot be modified)": "Current category (cannot be modified)",
        "Choose the main category of your ad": "Choose the main category of your ad",
        "Specify the exact product type (optional)": "Specify the exact product type (optional)",
        "Select compatible vehicle brands": "Select compatible vehicle brands",
        "Describe honestly the condition of your item": "Describe honestly the condition of your item",
        "Vehicle Brand *": "Vehicle Brand *",
        "Model *": "Model *",
        "Year *": "Year *",
        "Mileage (km) (Optional)": "Mileage (km) (Optional)",
        "Part Number/Reference": "Part Number/Reference",
        "Warranty": "Warranty",
        "Select a category": "Select a category",
        "Select a subcategory": "Select a subcategory",
        "Select condition": "Select condition",
        "Select a brand": "Select a brand",
        "ex: Camry, Civic, C3": "ex: Camry, Civic, C3",
        "ex: 2015": "ex: 2015",
        "ex: 150000": "ex: 150000",
        "ex: 12345-67890, OEM-REF-001": "ex: 12345-67890, OEM-REF-001",
        "ex: 6 months, 1 year, None": "ex: 6 months, 1 year, None",
        "OEM number or manufacturer reference": "OEM number or manufacturer reference",
        "Warranty duration offered": "Warranty duration offered",
        "category(ies) available": "category(ies) available",
        "subcategory(ies) available": "subcategory(ies) available",
        "condition(s) available": "condition(s) available",
        "brand(s) available": "brand(s) available",
        "Search for a category...": "Search for a category...",
        "Search for a subcategory...": "Search for a subcategory...",
        "Search for a condition...": "Search for a condition...",
        "Search for a brand...": "Search for a brand...",
        "Unable to load categories": "Unable to load categories",
        "Category service unavailable": "Category service unavailable",
        "Server error. Please try again later.": "Server error. Please try again later.",
        "Unable to connect to server. Check your connection.": "Unable to connect to server. Check your connection.",
        "Invalid data format": "Invalid data format",
        "Error loading categories:": "Error loading categories:",
        "Error loading subcategories:": "Error loading subcategories:",
        "Loading subcategories...": "Loading subcategories...",
        "No category found": "No category found",
        "No subcategory available": "No subcategory available",
        "Try with another search term": "Try with another search term",
        "No subcategory for this category": "No subcategory for this category",
        "Try with another term": "Try with another term",
        "⟳ Retry": "⟳ Retry",
        "New": "New",
        "Like New": "Like New",
        "Good Condition": "Good Condition",
        "Fair Condition": "Fair Condition",
        "Poor Condition": "Poor Condition",
        "For Parts Only": "For Parts Only",
        "Toyota": "Toyota",
        "Honda": "Honda",
        "Nissan": "Nissan",
        "Mercedes-Benz": "Mercedes-Benz",
        "BMW": "BMW",
        "Volkswagen": "Volkswagen",
        "Peugeot": "Peugeot",
        "Renault": "Renault",
        "Hyundai": "Hyundai",
        "Kia": "Kia",
        "Ford": "Ford",
        "Chevrolet": "Chevrolet",
        "Audi": "Audi",
        "Mazda": "Mazda",
        "Suzuki": "Suzuki",
        "Mitsubishi": "Mitsubishi",
        "Subaru": "Subaru",
        "Lexus": "Lexus",
        "Jeep": "Jeep",
        "Land Rover": "Land Rover",
        "Pièces Auto": "Auto Parts",
        "Véhicules Complets": "Complete Vehicles",
        "Pièces détachées pour automobiles": "Spare parts for automobiles",
        "Spare parts for automobiles": "Spare parts for automobiles",
        "Pièces détachées pour motos": "Spare parts for motorcycles",
        "Spare parts for motorcycles": "Spare parts for motorcycles",
        "Moteurs complets et pièces moteur": "Complete engines and engine parts",
        "Complete engines and engine parts": "Complete engines and engine parts",
        "Pièces de carrosserie et tôlerie": "Bodywork and sheet metal parts",
        "Bodywork and sheet metal parts": "Bodywork and sheet metal parts",
        "Véhicules complets à vendre": "Complete vehicles for sale",
        "Complete vehicles for sale": "Complete vehicles for sale",
        "Loading error": "Loading error",
        "Detecting your country...": "Detecting your country...",
        "Find Auto Parts in": "Find Auto Parts in",
        "Find Auto Parts": "Find Auto Parts",
        "Marketplace for new and used automotive parts, complete vehicles and auto services": "Marketplace for new and used automotive parts, complete vehicles and auto services",
        "Search parts, brands, models...": "Search parts, brands, models...",
        "Search": "Search",
        "Voice Search": "Voice Search",
        "Advanced Search": "Advanced Search",
        "Recording simulation...": "Recording simulation...",
        "Processing simulation...": "Processing simulation...",
        "Press the button to simulate voice recognition": "Press the button to simulate voice recognition",
        "Simulated text:": "Simulated text:",
        "Simulated examples:": "Simulated examples:",
        "This is a simulation. Text is randomly generated.": "This is a simulation. Text is randomly generated.",
        "Start simulation": "Start simulation",
        "Stop": "Stop",
        "Use text": "Use text",
        "No text": "No text",
        "Please record a voice search first": "Please record a voice search first",
        "Location Permission": "Location Permission",
        "This app needs access to your location to show auto parts available in your country.": "This app needs access to your location to show auto parts available in your country.",
        "Ask Later": "Ask Later",
        "Cancel": "Cancel",
        "OK": "OK",
        "Toyota tires": "Toyota tires",
        "Peugeot 206 engine": "Peugeot 206 engine",
        "front brakes": "front brakes",
        "Audi A4 headlight": "Audi A4 headlight",
        "Renault bumper": "Renault bumper",
        "car battery": "car battery",
        "new shock absorbers": "new shock absorbers",
        "Mercedes steering wheel": "Mercedes steering wheel",
        "leather seats": "leather seats",
        "truck horn": "truck horn",
        "Confidentialité & Paramètres": "Privacy & Settings",
        "Contrôlez la visibilité de votre profil et vos préférences de communication": "Control your profile visibility and communication preferences",
        "Préférences de Langue": "Language Preferences",
        "Langue de l'interface": "Interface Language",
        "Choisissez votre langue préférée pour l'interface de l'application": "Choose your preferred language for the application interface",
        "Français": "French",
        "English": "English",
        "Paramètres de Notification": "Notification Settings",
        "Notifications par email": "Email Notifications",
        "Recevoir des mises à jour importantes par email": "Receive important updates by email",
        "Notifications SMS": "SMS Notifications",
        "Recevoir des notifications urgentes par SMS": "Receive urgent notifications by SMS",
        "Notifications WhatsApp": "WhatsApp Notifications",
        "Recevoir des notifications sur WhatsApp": "Receive notifications on WhatsApp",
        "Données & Confidentialité": "Data & Privacy",
        "Autoriser l'analyse des données": "Allow data analysis",
        "Aidez à améliorer la plateforme en partageant des données d'utilisation anonymes": "Help improve the platform by sharing anonymous usage data",
        "Rcommandations personnalisées": "Personalized Recommendations",
        "Afficher des recommandations de pièces personnalisées basées sur votre activité": "Display personalized recommendations based on your activity",
        "Sécurité du Compte": "Account Security",
        "Notifications de connexion": "Login Notifications",
        "Soyez informé lorsque quelqu'un se connecte à votre compte": "Be notified when someone logs into your account",
        "Gestion des Données": "Data Management",
        "Se deconnecter": "Logout",
        "Supprimer le Compte": "Delete Account",
        "La suppression du compte est permanente et ne peut pas être annulée. Toutes vos annonces et données seront supprimées.": "Account deletion is permanent and cannot be undone. All your ads and data will be deleted.",
        "Public - Visible par tous": "Public - Visible to all",
        "Utilisateurs Vérifiés Uniquement": "Verified Users Only",
        "Privé - Caché des autres": "Private - Hidden from others",
        "WhatsApp uniquement": "WhatsApp only",
        "Appels téléphoniques uniquement": "Phone calls only",
        "WhatsApp & Téléphone": "WhatsApp & Phone",
        "Pas de contact direct": "No direct contact",
        "Sauvegarder": "Save",
        "Réinitialiser": "Reset",
        "Exporter les Données": "Export Data",
        "Supprimer": "Delete",
        "Annuler": "Cancel",
        "Oui": "Yes",
        "Succès": "Success",
        "Erreur": "Error",
        "Paramètres sauvegardés avec succès": "Settings saved successfully",
        "Paramètres restaurés": "Settings have been reset",
        "Fonctionnalité bientôt disponible": "Feature coming soon",
        "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.": "Are you sure you want to delete your account? This action is irreversible.",
        "Compte Supprimé": "Account Deleted",
        "Votre compte a été supprimé": "Your account has been deleted",
        "loading": "Loading...",
        "error": "Error"
      }
    },
    fr: {
      translation: {
        "rechercher": {
          "title": "Rechercher",
          "searchPlaceholder": "Rechercher un produit...",
          "searchPlaceholderDetailed": "Rechercher un produit, marque, modèle...",
          "searchResults": "Résultats de recherche",
          "allProducts": "Tous les produits",
          "filters": {
            "title": "Filtres",
            "apply": "Appliquer",
            "reset": "Réinitialiser",
            "activeFilters": "Filtres actifs",
            "clearAll": "Tout effacer",
            "location": {
              "title": "📍 Localisation",
              "locateMe": "Me localiser",
              "locating": "Localisation en cours...",
              "currentLocation": "Utiliser ma position actuelle",
              "permission": {
                "title": "Permission de localisation",
                "message": "Cette application a besoin de votre localisation pour trouver des produits près de chez vous.",
                "android": "Permission de localisation refusée",
                "ios": "Erreur de permission iOS",
                "enable": "Activez la localisation dans les paramètres"
              }
            },
            "price": {
              "title": "💰 Prix",
              "min": "Min (FCFA)",
              "max": "Max (FCFA)",
              "unlimited": "Illimité"
            },
            "condition": {
              "title": "⚡ État",
              "all": "Tous états",
              "new": "Neuf",
              "likeNew": "Comme neuf",
              "good": "Bon état",
              "fair": "État correct",
              "poor": "Mauvais état",
              "forParts": "Pour pièces uniquement"
            },
            "country": {
              "title": "🌍 Pays",
              "searchPlaceholder": "Rechercher un pays...",
              "noResults": "Aucun pays trouvé"
            },
            "city": {
              "title": "🏙️ Ville",
              "searchPlaceholder": "Rechercher une ville..."
            }
          },
          "results": {
            "found": "{{count}} produit trouvé",
            "found_plural": "{{count}} produits trouvés",
            "loading": "Recherche en cours...",
            "noResults": {
              "title": "Aucun résultat trouvé",
              "description": "Aucun produit correspondant à votre recherche",
              "modifySearch": "Modifier la recherche",
              "setAlert": "Mettre en alerte"
            },
            "end": "🎯 Fin des résultats",
            "loadingMore": "Chargement..."
          },
          "alerts": {
            "title": "🔔 Créer une alerte",
            "subtitle": "Soyez notifié dès qu'un produit correspondant est disponible",
            "types": {
              "basic": {
                "name": "Alerte Basique",
                "duration": "7 jours",
                "features": [
                  "Notification par email",
                  "1 recherche sauvegardée",
                  "Support standard"
                ]
              },
              "pro": {
                "name": "Alerte Pro",
                "duration": "30 jours",
                "features": [
                  "Notifications email et SMS",
                  "5 recherches sauvegardées",
                  "Support prioritaire",
                  "Statistiques détaillées"
                ]
              },
              "premium": {
                "name": "Alerte Premium",
                "duration": "90 jours",
                "features": [
                  "Notifications en temps réel",
                  "Recherches illimitées",
                  "Support 24/7",
                  "Analyses avancées",
                  "Alertes personnalisées"
                ]
              }
            },
            "info": "🔔 Activez une alerte pour être notifié dès qu'un produit correspondant est disponible.",
            "select": "Sélectionner",
            "selected": "Sélectionné",
            "cancel": "Annuler",
            "continue": "Continuer"
          },
          "payment": {
            "title": "💳 Méthode de paiement",
            "selectMethod": "Sélectionnez votre méthode de paiement",
            "total": "Total: {{amount}}",
            "methods": {
              "mobile_money": "Mobile Money",
              "mobile_money_desc": "Orange Money, MTN Mobile Money",
              "credit_card": "Carte bancaire",
              "credit_card_desc": "Visa, Mastercard",
              "paypal": "PayPal",
              "paypal_desc": "Paiement sécurisé"
            },
            "details": {
              "title": "Informations de paiement",
              "processing": "Traitement du paiement en cours...",
              "operator": "Opérateur",
              "phone": "Numéro de téléphone",
              "cardNumber": "Numéro de carte",
              "expiry": "Date d'expiration",
              "cvv": "CVV",
              "pay": "Payer {{amount}}"
            },
            "confirmation": {
              "title": "Paiement réussi !",
              "amount": "Montant payé",
              "duration": "Durée",
              "reference": "Référence",
              "viewAlerts": "Voir mes alertes"
            }
          },
          "errors": {
            "loading": "Erreur de chargement",
            "timeout": "Temps d'attente dépassé",
            "server": "Erreur serveur",
            "connection": "Pas de connexion au serveur",
            "geolocation": "Erreur de localisation",
            "geocoding": "Erreur de géocodage"
          },
          "buttons": {
            "back": "Retour",
            "search": "Rechercher",
            "filter": "Filtrer",
            "sort": "Trier",
            "close": "Fermer",
            "ok": "OK",
            "yes": "Oui",
            "no": "Non"
          },
          "product": {
            "negotiable": "Nég.",
            "unknownLocation": "Ville, Pays",
            "share": "Partager",
            "contact": "Contacter",
            "viewDetails": "Voir détails"
          }
        },
        "user": "Utilisateur",
        "seller": {
          "defaultName": "Vendeur",
          "listings": "Annonces",
          "memberSince": "Membre depuis",
          "noListings": "Ce vendeur n'a pas encore publié d'annonces",
          "allProducts": "Tous les produits ({{count}})",
          "clickForDetails": "Cliquez sur un produit pour voir les détails",
          "unspecifiedAddress": "Adresse non spécifiée",
          "fullName": "Nom complet",
          "phone": "Téléphone",
          "address": "Adresse",
          "accountType": "Type de compte",
          "professional": "Professionnel",
          "individual": "Particulier",
          "business": "Entreprise",
          "businessPhone": "Téléphone Pro",
          "businessEmail": "Email Pro",
          "website": "Site Web",
          "businessAddress": "Adresse Pro",
          "specialties": "Spécialités"
        },
        "titles": {
          "sellerProfile": "Profil Vendeur"
        },
        "sections": {
          "description": "Description",
          "professionalInfo": "Informations Professionnelles",
          "contactInfo": "Coordonnées"
        },
        "tabs": {
          "products": "Produits",
          "contact": "Contact"
        },
        "buttons": {
          "retry": "Réessayer",
          "login": "Se connecter",
          "call": "Appeler",
          "message": "Message"
        },
        "badges": {
          "new": "Nouveau",
          "premium": "Premium",
          "pro": "PRO"
        },
        "sellerTypes": {
          "garage": "Garage",
          "mechanic": "Mécanicien"
        },
        "conditions": {
          "new": "Neuf",
          "likeNew": "Comme neuf",
          "used": "Occasion",
          "good": "Bon état",
          "excellent": "Excellent état"
        },
        "timeAgo": {
          "hours": "Il y a {{count}}h",
          "days": "Il y a {{count}}j"
        },
        "sampleProducts": {
          "transmission": "Boîte de vitesses automatique Honda Accord",
          "condition": "Occasion - Excellent état"
        },
        "whatsappMessage": "Bonjour, je suis intéressé par vos annonces sur Autocasses",
        "errors": {
          "missingUserId": "ID utilisateur manquant",
          "noUserData": "Aucune donnée utilisateur reçue",
          "invalidProductFormat": "Format de réponse invalide pour les produits",
          "loadingError": "Erreur de chargement des données",
          "sessionExpired": "Session expirée. Veuillez vous reconnecter.",
          "unauthorized": "Accès non autorisé",
          "userNotFound": "Utilisateur non trouvé",
          "noConnection": "Pas de connexion au serveur"
        },
        "alerts": {
          "error": "Erreur",
          "info": "Information",
          "cannotOpenPhone": "Impossible d'ouvrir l'application téléphone",
          "phoneNotAvailable": "Numéro de téléphone non disponible",
          "whatsappNotInstalled": "WhatsApp n'est pas installé sur votre appareil",
          "cannotOpenEmail": "Impossible d'ouvrir l'application email",
          "emailNotAvailable": "Adresse email non disponible",
          "cannotOpenWebsite": "Impossible d'ouvrir le site web",
          "cannotOpenMaps": "Impossible d'ouvrir l'application cartes"
        },
        "loading": {
          "profile": "Chargement du profil..."
        },
        "productDetails": {
          "loading": "Chargement des détails du produit...",
          "buttons": {
            "backToSearch": "Retour à la recherche",
            "share": "Partager",
            "favorites": "Favoris",
            "contactSeller": "Contacter le vendeur",
            "showLess": "Voir moins",
            "readMore": "Lire la suite"
          },
          "sections": {
            "specifications": "Spécifications",
            "description": "Description",
            "additionalInfo": "Informations complémentaires"
          },
          "specifications": {
            "category": "Catégorie",
            "subcategory": "Sous-catégorie",
            "brand": "Marque",
            "location": "Localisation",
            "partNumber": "Numéro de pièce",
            "warranty": "Garantie",
            "exchange": "Échange accepté",
            "negotiable": "Négociable",
            "country": "Pays",
            "city": "Ville",
            "address": "Adresse",
            "warrantyMonths": "{{months}} mois"
          },
          "fields": {
            "negotiable": "Négociable",
            "exchangeAccepted": "Échange accepté",
            "availability": "Disponibilité"
          },
          "stock": {
            "inStock": "En stock",
            "outOfStock": "Rupture de stock"
          },
          "conditions": {
            "new": "Neuf",
            "newFeminine": "Neuve",
            "used": "Occasion",
            "good": "Bon état",
            "excellent": "Excellent",
            "average": "État moyen",
            "poor": "Mauvais état",
            "repaired": "Réparé",
            "refurbished": "Reconditionné",
            "unknown": "Inconnu"
          },
          "warranty": {
            "months": "{{months}} mois de garantie",
            "none": "Pas de garantie"
          },
          "defaults": {
            "productImage": "Image du produit",
            "unknownSeller": "Vendeur inconnu",
            "untitled": "Sans titre",
            "category": "Catégorie {{id}}",
            "subcategory": "Sous-catégorie {{id}}",
            "unspecifiedBrand": "Marque non spécifiée",
            "noDescription": "Pas de description disponible.",
            "unknownCity": "Ville inconnue",
            "unknownRegion": "Région inconnue"
          },
          "seller": {
            "defaultBio": "Vendeur sur AutoCasse",
            "responseTime": "< 24 heures",
            "businessHours": {
              "monday": "9h00 - 18h00",
              "tuesday": "9h00 - 18h00",
              "wednesday": "9h00 - 18h00",
              "thursday": "9h00 - 18h00",
              "friday": "9h00 - 18h00",
              "saturday": "9h00 - 13h00",
              "sunday": "Fermé"
            },
            "infoUnavailable": "Informations du vendeur non disponibles"
          },
          "protection": {
            "title": "Protection AutoCasse",
            "secureTransactions": "Transactions sécurisées",
            "customerSupport": "Support client 24/7",
            "fraudProtection": "Protection contre la fraude"
          },
          "contact": {
            "whatsappUnavailable": "Numéro WhatsApp non disponible. Contactez le vendeur par téléphone.",
            "whatsappMessage": "Bonjour, je suis intéressé(e) par votre annonce \"{{title}}\" sur AutoCasses. Prix: {{price}} XAF",
            "phoneUnavailable": "Numéro de téléphone non disponible"
          },
          "share": {
            "message": "Découvrez cette annonce sur AutoCasses\n\n{{title}}\nPrix: {{price}} XAF\n\nTéléchargez l'app AutoCasse: {{appLink}}"
          },
          "notifications": {
            "addedToFavorites": {
              "title": "Article ajouté aux favoris",
              "message": "l'article {{title}} a été ajouté aux favoris"
            },
            "removedFromFavorites": {
              "title": "Article retiré des favoris",
              "message": "l'article {{title}} a été retiré des favoris"
            }
          },
          "alerts": {
            "sessionExpiredTitle": "Session expirée",
            "sessionExpiredMessage": "Votre session a expiré. Voulez-vous vous reconnecter?",
            "reconnect": "Se reconnecter",
            "authenticationProblem": "Problème d'authentification",
            "retryWithoutAuth": "Voulez-vous réessayer sans authentification?"
          },
          "logs": {
            "tokenExpired": "Token expiré ou invalide, tentative sans token...",
            "sellerInfoRetrieved": "Informations vendeur récupérées: {{hasInfo}}",
            "noUserId": "Pas d'ID utilisateur dans les données du produit"
          },
          "warnings": {
            "categoryDetails": "Impossible de récupérer les détails de la catégorie:",
            "invalidSellerResponse": "Format de réponse invalide pour le vendeur"
          }
        },
        "commonsssss": {
          "error": "Erreur",
          "info": "Information",
          "cancel": "Annuler",
          "retry": "Réessayer",
          "back": "Retour",
          "later": "Plus tard",
          "yes": "Oui",
          "no": "Non"
        },
        "auctionDetails": {
          "header": {
            "title": "Détails de l'enchère"
          },
          "timer": {
            "days": "J",
            "hours": "H",
            "minutes": "M",
            "seconds": "S",
            "ended": "Enchère terminée"
          },
          "loading": "Chargement des détails...",
          "noPhotos": "Aucune photo disponible",
          "status": {
            "active": "En cours",
            "ended": "Terminée"
          },
          "uncategorized": "Non catégorisé",
          "currentPrice": "Prix actuel",
          "startingPrice": "Prix de départ",
          "bidStep": "Pas d'enchère: {{step}}",
          "duration": "Durée : {{hours}} heure{{plural}}",
          "tabs": {
            "description": "Description",
            "offers": "Offres",
            "questions": "Questions"
          },
          "noDescription": "Aucune description disponible",
          "location": "Localisation",
          "condition": "État",
          "startDate": "Début",
          "estimatedEnd": "Fin estimée",
          "notSpecified": "Non spécifié",
          "notDefined": "Non définie",
          "additionalInfo": "Informations additionnelles",
          "region": "Région",
          "detailedAddress": "Adresse détaillée",
          "landmark": "Point de repère",
          "warranty": "Garantie",
          "negotiable": "Négociable",
          "exchangePossible": "Échange possible",
          "bidStepLabel": "Pas d'enchère",
          "seller": "Vendeur",
          "sellerDefault": "Vendeur",
          "locationNotSpecified": "Localisation non spécifiée",
          "bids": {
            "noBids": "Aucune offre pour le moment",
            "beFirst": "Soyez le premier à faire une offre !",
            "user": "Utilisateur {{id}}",
            "unknownDate": "Date inconnue",
            "at": "à",
            "bidPlaced": "Votre offre a été enregistrée !",
            "registrationError": "Erreur lors de l'enregistrement"
          },
          "questions": {
            "askQuestion": "Poser une question",
            "questionPlaceholder": "Avez-vous une question sur ce produit ?",
            "charCount": "{{current}}/500 caractères",
            "noQuestions": "Aucune question pour le moment",
            "beFirst": "Soyez le premier à poser une question !",
            "anonymous": "Anonyme",
            "seller": "Vendeur",
            "reply": "Répondre",
            "replyPlaceholder": "Tapez votre réponse...",
            "replyError": "Impossible d'envoyer la réponse",
            "writeQuestion": "Veuillez écrire une question",
            "mustLogin": "Vous devez être connecté pour poser une question",
            "questionPublished": "Votre question a été publiée",
            "publishError": "Impossible de publier la question"
          },
          "auth": {
            "required": "Connexion requise",
            "mustLogin": "Vous devez être connecté pour faire une offre.",
            "login": "Se connecter",
            "notAuthenticated": "Non authentifié"
          },
          "makeBid": "Faire une offre",
          "auctionEnded": "Enchère terminée",
          "contact": {
            "title": "Contact",
            "noContact": "Aucun contact disponible pour ce vendeur"
          },
          "bidModal": {
            "title": "Faire une offre",
            "currentPrice": "Prix actuel",
            "yourBid": "Votre offre (FCFA)",
            "bidStep": "Pas d'enchère: {{step}}",
            "bidHint": "L'offre doit être supérieure au prix actuel",
            "submitBid": "Soumettre l'offre",
            "invalidBid": "Offre invalide",
            "enterValidAmount": "Veuillez entrer un montant valide",
            "mustBeHigher": "Votre offre doit être supérieure à {{price}}",
            "tooLow": "Offre trop basse",
            "minimumBid": "L'offre minimum est de {{price}}"
          }
        },
        "commonssss": {
          "error": "Erreur",
          "success": "Succès",
          "cancel": "Annuler",
          "send": "Envoyer",
          "publish": "Publier",
          "back": "Retour",
          "ok": "OK",
          "yes": "Oui",
          "no": "Non"
        },
        "locationInput": {
          "header": {
            "title": "📍 Localisation",
            "subtitle": "Où se trouve votre article ?"
          },
          "buttons": {
            "locateMe": "Me localiser"
          },
          "recent": {
            "title": "Récentes"
          },
          "fields": {
            "country": "Pays",
            "city": "Ville",
            "fullAddress": "Adresse complète (optionnelle)",
            "fullAddressPlaceholder": "Numéro, rue, code postal...",
            "fullAddressDescription": "Pour votre usage personnel - non affichée publiquement"
          },
          "selectors": {
            "countryPlaceholder": "Sélectionner un pays",
            "cityPlaceholder": "Sélectionner une ville"
          },
          "validation": {
            "title": "Localisation complète",
            "text": "Tous les champs requis sont remplis"
          },
          "preview": {
            "title": "Aperçu de la localisation",
            "subtitle": "Ce que les acheteurs verront",
            "info": "Seule la ville et le pays seront visibles. L'adresse reste confidentielle."
          },
          "privacy": {
            "title": "Confidentialité garantie",
            "tip1": "Votre adresse exacte n'est jamais partagée publiquement",
            "tip2": "Les acheteurs ne voient que la ville et le pays",
            "tip3": "Proposez toujours des lieux publics pour les rencontres"
          },
          "clear": {
            "title": "Effacer la localisation",
            "message": "Voulez-vous vraiment effacer toutes les informations de localisation ?"
          },
          "modals": {
            "country": {
              "title": "Sélectionnez un pays",
              "subtitle": "{{count}} pays disponible(s)"
            },
            "city": {
              "title": "Sélectionnez une ville",
              "subtitle": "{{country}} • {{count}} ville(s)"
            },
            "searchCountry": "Rechercher un pays, une capitale...",
            "searchCity": "Rechercher une ville...",
            "noCountries": "Aucun pays trouvé",
            "noCities": "Aucune ville trouvée",
            "tryOtherSearch": "Essayez avec un autre terme de recherche",
            "noCitiesForCountry": "Aucune ville disponible pour ce pays"
          }
        },
        "commonsss": {
          "cancel": "Annuler",
          "clear": "Effacer"
        },
        "createListing": {
          "header": {
            "create": "Créer une Annonce",
            "edit": "Modifier l'Annonce"
          },
          "steps": {
            "photos": "Photos",
            "category": "Catégorie",
            "description": "Description",
            "pricing": "Prix",
            "location": "Localisation",
            "contact": "Contact",
            "preview": "Aperçu"
          },
          "stepDescriptions": {
            "photos": "Ajoutez des images du produit (max 8)",
            "category": "Sélectionnez la catégorie et spécifiez les détails",
            "description": "Donnez un titre attractif et décrivez votre produit",
            "pricing": "Fixez votre prix et indiquez si négociable",
            "location": "Indiquez le pays et la ville où se trouve le produit",
            "contact": "Comment les acheteurs peuvent vous contacter",
            "preview": "Vérifiez toutes les informations avant publication"
          },
          "progress": {
            "step": "Étape {{current}} sur {{total}}",
            "percentage": "{{percent}}% Terminé"
          },
          "validation": {
            "incompleteForm": "Formulaire incomplet",
            "fillAllFields": "Veuillez remplir tous les champs obligatoires.",
            "fillRequiredFields": "Veuillez remplir tous les champs obligatoires pour continuer",
            "mustBeLoggedIn": "Vous devez être connecté pour créer une annonce"
          },
          "buttons": {
            "proceedToPayment": "Procéder au Paiement",
            "publishListing": "Publier l'Annonce"
          },
          "upload": {
            "editing": "Modification en cours...",
            "sending": "Envoi en cours..."
          },
          "loading": {
            "productData": "Chargement des données du produit..."
          },
          "success": {
            "title": "Succès",
            "create": "Votre produit a été ajouté avec succès!",
            "edit": "Votre produit a été modifié avec succès!"
          },
          "delete": {
            "confirmation": "Confirmation",
            "message": "Êtes-vous sûr de vouloir supprimer ce produit ? Cette action est irréversible.",
            "success": "Le produit a été supprimé avec succès.",
            "error": "Impossible de supprimer le produit"
          },
          "payment": {
            "title": "Paiement pour l'Annonce",
            "description": "Payez pour activer votre annonce avec les fonctionnalités sélectionnées",
            "failed": "Paiement Échoué",
            "tryAgain": "Le paiement a échoué. Veuillez réessayer."
          },
          "description": {
            "titleLabel": "Titre de l'Annonce",
            "titlePlaceholder": "ex: Plaquettes de Frein Toyota Camry - Pièces d'Origine",
            "titleDescription": "Créez un titre attractif et descriptif",
            "detailedDescription": "Description Détaillée *",
            "descriptionPlaceholder": "Décrivez votre article en détail...\\n\\n• État et âge\\n• Exigences d'installation\\n• Détails de compatibilité\\n• Défauts ou problèmes\\n• Raison de la vente",
            "characterCount": "{{current}}/2000 caractères",
            "keyFeatures": "Caractéristiques Clés (Optionnel)",
            "featurePlaceholder": "ex: Pièce OEM d'origine",
            "addFeature": "Ajouter une Caractéristique"
          },
          "existingPhotoName": "photo_existante_{{index}}.jpg",
          "photoName": "photo_{{timestamp}}_{{index}}.jpg"
        },
        "commons": {
          "ok": "OK",
          "cancel": "Annuler",
          "delete": "Supprimer",
          "previous": "Précédent",
          "next": "Suivant",
          "update": "Mettre à jour",
          "editMode": "Mode Édition"
        },
        "pricingSection": {
          "header": {
            "title": "💰 Prix & Conditions",
            "subtitle": "Fixez le prix en FCFA et définissez les modalités de vente"
          },
          "priceInput": {
            "label": "Prix de vente (FCFA) *",
            "description": "Indiquez le prix en Francs CFA auquel vous souhaitez vendre",
            "placeholder": "0"
          },
          "currency": "FCFA",
          "pricePreview": "Prix défini : {{price}}",
          "salesOptions": {
            "label": "Options de vente",
            "description": "Ajoutez des flexibilités pour attirer plus d'acheteurs"
          },
          "options": {
            "negotiable": {
              "title": "Prix négociable",
              "description": "Acceptez les offres de prix inférieures"
            },
            "trade": {
              "title": "Échange accepté",
              "description": "Acceptez les échanges contre d'autres produits"
            }
          },
          "preview": {
            "title": "Aperçu pour les acheteurs",
            "priceLabel": "Prix demandé",
            "info": "Les acheteurs verront ce prix avec les options que vous avez sélectionnées"
          },
          "badges": {
            "negotiable": "Négociable",
            "trade": "Échange possible"
          },
          "tips": {
            "title": "Conseils pour fixer votre prix",
            "compare": "Comparez avec des annonces similaires sur la plateforme",
            "negotiable": "Un prix légèrement négociable attire plus d'acheteurs",
            "trade": "Acceptez les échanges pour élargir vos opportunités"
          },
          "format": {
            "priceZero": "0 FCFA",
            "price": "{{price}} FCFA"
          }
        },
        "commonss": {
          "editMode": "Mode Édition"
        },
        "photoUpload": {
          "title": "📸 Photos du Produit",
          "subtitle": "Montrez votre produit sous tous ses angles",
          "limitReached": "Limite atteinte",
          "addPhotos": "Ajouter des photos",
          "selectPhotos": "Sélectionnez ou prenez des photos de haute qualité",
          "maxReached": "Maximum {{max}} photos atteint",
          "stats": "{{current}} sur {{max}} photos",
          "editMode": "Mode Édition",
          "searchPlaceholder": "Rechercher parmi les photos...",
          "noPhotosFound": "Aucune photo trouvée",
          "allPhotos": "Toutes les photos",
          "noPhotos": "Aucune photo",
          "emptyState": "Ajoutez des photos pour montrer votre produit sous tous ses angles",
          "gallery": "Galerie",
          "camera": "Caméra",
          "tips": {
            "title": "Conseils photo professionnels",
            "primary": {
              "title": "Photo Principale",
              "text": "Utilisez l'image la plus attractive comme première photo"
            },
            "lighting": {
              "title": "Bonne Lumière",
              "text": "Photographiez en plein jour avec une lumière naturelle"
            },
            "angles": {
              "title": "Multiples Angles",
              "text": "Montrez le produit sous différents angles"
            },
            "transparency": {
              "title": "Transparence",
              "text": "Montrez clairement tout défaut ou usure"
            }
          },
          "badges": {
            "primary": "Principale",
            "existing": "Existant"
          },
          "actions": {
            "photo": "Actions Photo",
            "setPrimary": "Définir comme principale",
            "moveUp": "Déplacer vers le haut",
            "moveDown": "Déplacer vers le bas",
            "delete": "Supprimer la photo",
            "deleteTitle": "Supprimer la photo",
            "deleteMessage": "Êtes-vous sûr de vouloir supprimer cette photo ?",
            "cancel": "Annuler",
            "deleteButton": "Supprimer",
            "info": "Information",
            "cannotChangePrimary": "La photo principale ne peut pas être modifiée en mode édition",
            "cannotReorder": "La réorganisation n'est disponible que pour les nouvelles photos"
          },
          "modals": {
            "imageInfo": "Informations Image",
            "fileSize": "{{size}} Mo",
            "loadingError": "Impossible de charger cette image"
          }
        },
        "headers": {
          "navigation": "Navigation",
          "categories": "Catégories",
          "loadingCategories": "Chargement des catégories...",
          "noCategories": "Aucune catégorie disponible",
          "retry": "Réessayer",
          "account": "Mon Compte",
          "myProfile": "Mon Profil",
          "profileDescription": "Gérer mon compte",
          "myFavorites": "Mes Favoris",
          "favoritesDescription": "Articles sauvegardés",
          "logout": "Déconnexion",
          "subcategories": "Sous-catégories",
          "noSubcategories": "Aucune sous-catégorie disponible",
          "loadingSubcategories": "Chargement...",
          "searchCategory": "Rechercher la catégorie",
          "usersCount": "{{count}} utilisateurs",
          "favoritesBadge": "{{count}}"
        },
        "menu": {
          "open": "Ouvrir le menu",
          "close": "Fermer le menu",
          "search": "Rechercher",
          "viewAll": "Voir tout"
        },
        "categories": {
          "engine": "MOTEUR & COMPOSANTS",
          "transmission": "TRANSMISSION",
          "brakes": "FREINS",
          "suspension": "SUSPENSION",
          "bodywork": "CARROSSERIE"
        },
        "favorites": {
          "title": "Mes Favoris",
          "loading": "Chargement de vos favoris...",
          "error": {
            "title": "Oups !",
            "connection": "Pas de connexion internet",
            "unauthorized": "Veuillez vous connecter pour voir vos favoris",
            "forbidden": "Accès non autorisé",
            "generic": "Une erreur est survenue",
            "loading": "Erreur lors du chargement des favoris"
          },
          "empty": {
            "title": "Aucun favori",
            "description": "Vous n'avez encore aucun produit dans vos favoris."
          },
          "stats": {
            "count": "{{count}} produit{{plural}} favori{{plural}}",
            "removeAll": "Supprimer tous les favoris"
          },
          "product": {
            "condition": {
              "new": "Neuf",
              "excellent": "Excellent",
              "good": "Bon",
              "fair": "Moyen",
              "poor": "Mauvais",
              "unknown": "État inconnu"
            },
            "seller": "Vendeur",
            "location": "Localisation",
            "contact": "Contacter",
            "share": "Partager",
            "remove": "Retirer des favoris",
            "viewDetails": "Voir les détails"
          },
          "actions": {
            "retry": "Réessayer",
            "search": "Découvrir des produits",
            "home": "Retour à l'accueil",
            "clearAll": "Tout effacer",
            "remove": "Retirer",
            "cancel": "Annuler"
          },
          "alerts": {
            "removeTitle": "Retirer des favoris",
            "removeMessage": "Êtes-vous sûr de vouloir retirer ce produit de vos favoris ?",
            "clearAllTitle": "Vider les favoris",
            "clearAllMessage": "Êtes-vous sûr de vouloir vider tous vos favoris ?",
            "successRemove": "Produit retiré des favoris",
            "successClearAll": "Tous les favoris ont été supprimés",
            "errorRemove": "Impossible de retirer le produit des favoris",
            "errorClearAll": "Impossible de vider les favoris",
            "contact": "Contacter le vendeur",
            "share": "Partager ce produit"
          },
          "header": {
            "favoritesList": "Vos produits préférés"
          }
        },
        "verification": {
          "title": "Vérification d'Identité",
          "subtitle": "Complétez la vérification pour établir la confiance et débloquer les fonctionnalités premium",
          "completed": "Terminé",
          "progress": "Progression de la vérification",
          "verificationSteps": {
            "phone": {
              "title": "Vérification Téléphone",
              "description": "Vérifiez votre numéro de téléphone par SMS"
            },
            "whatsapp": {
              "title": "Vérification WhatsApp",
              "description": "Vérifiez votre numéro WhatsApp"
            },
            "identity": {
              "title": "Document d'Identité",
              "description": "Téléchargez une carte d'identité ou un passeport"
            },
            "photo": {
              "title": "Photo de Profil",
              "description": "Téléchargez une photo claire de vous-même"
            }
          },
          "status": {
            "completed": "Complété",
            "pending": "En attente",
            "rejected": "Rejeté",
            "uploading": "Téléchargement..."
          },
          "actions": {
            "upload": "Télécharger",
            "retry": "Réessayer"
          },
          "documents": {
            "title": "Documents Téléchargés",
            "identity": "Document d'Identité",
            "photo": "Photo de Profil",
            "status": "Statut : {{status}}"
          },
          "success": {
            "title": "Vérification Terminée !",
            "description": "Vous avez maintenant accès aux fonctionnalités premium, au badge vendeur professionnel et à une confiance accrue des acheteurs."
          },
          "benefits": {
            "premium": "Fonctionnalités Premium",
            "badge": "Badge Vendeur Professionnel",
            "trust": "Confiance des Acheteurs"
          }
        },
        "common": {
          "cancel": "Annuler",
          "confirm": "Confirmer",
          "success": "Succès",
          "error": "Erreur",
          "currency": "FCFA",
          "hours": "heures",
          "duration": "Durée",
          "currentPrice": "Prix actuel",
          "noTitle": "Sans titre",
          "save": "Enregistrer",
          "edit": "Modifier",
          "delete": "Supprimer",
          "view": "Voir"
        },
        "header": {
          "title": "Mes Produits",
          "subtitle": "Gérez vos annonces et enchères"
        },
        "stats": {
          "total": "Total",
          "active": "Actifs",
          "inactive": "Inactifs",
          "sold": "Vendus"
        },
        "search": {
          "placeholder": "Rechercher un produit...",
          "clear": "Effacer la recherche"
        },
        "filters": {
          "all": "Tous",
          "active": "Actifs",
          "auction": "Enchères",
          "sold": "Vendus"
        },
        "product": {
          "status": {
            "active": "Actif",
            "sold": "Vendu"
          },
          "badges": {
            "sold": "Vendu",
            "negotiable": "Négociable",
            "exchange": "Échange",
            "new": "Neuf",
            "likeNew": "Comme neuf"
          },
          "auction": "Enchère",
          "noDescription": "Pas de description",
          "unspecified": "Non spécifiée",
          "unknownDate": "Date inconnue"
        },
        "actions": {
          "view": "Voir",
          "auction": "Enchère",
          "stop": "Arrêter",
          "markSold": "Marquer vendu",
          "edit": "Modifier",
          "delete": "Supprimer",
          "addProduct": "Ajouter produit"
        },
        "auctionModal": {
          "title": "Lancer une enchère",
          "subtitle": "Configurez les paramètres de votre enchère",
          "productSection": {
            "title": "Produit sélectionné"
          },
          "settingsSection": {
            "title": "Paramètres de l'enchère"
          },
          "settings": {
            "startPrice": "Prix de lancement",
            "startPriceDescription": "Prix initial de l'enchère",
            "requiredField": "Champ obligatoire",
            "minBid": "Pas d'enchère minimum",
            "minBidDescription": "Augmentation minimum entre les offres",
            "optional": "Optionnel - laisser vide si pas de minimum",
            "duration": "Durée de l'enchère",
            "durationDescription": "Temps pendant lequel l'enchère sera active",
            "customDuration": "Ou durée personnalisée",
            "customPlaceholder": "Ex: 48",
            "maxDuration": "Durée maximum : {{hours}} heures (30 jours)"
          },
          "timeOptions": {
            "1day": "1 jour",
            "2days": "2 jours",
            "3days": "3 jours",
            "1week": "1 semaine",
            "2weeks": "2 semaines",
            "1month": "1 mois"
          },
          "validation": {
            "title": "Erreur de validation",
            "startPrice": "Veuillez définir un prix de lancement valide (minimum 1 FCFA).",
            "time": "Veuillez entrer un temps valide en heures (minimum 1 heure).",
            "maxTime": "La durée maximum est de {{hours}} heures (30 jours).",
            "minBid": "Le pas d'enchère minimum doit être un nombre positif.",
            "invalidTime": "La durée doit être entre 1 et {{hours}} heures.",
            "invalidPrice": "Le prix de lancement doit être supérieur à 0.",
            "invalidMinBid": "Le pas d'enchère minimum doit être supérieur à 0."
          },
          "confirmation": {
            "title": "Confirmation",
            "message": "Confirmez-vous le lancement de l'enchère ?\n\nDurée: {{duration}}\nPrix de départ: {{price}} FCFA\n{{minBid}}"
          },
          "info": {
            "title": "Informations importantes",
            "point1": "L'enchère sera visible immédiatement après validation",
            "point2": "Vous recevrez une notification pour chaque nouvelle offre",
            "point3": "Vous pouvez arrêter l'enchère à tout moment depuis cette interface",
            "point4": "Une commission de 5% sera prélevée sur le prix final de vente"
          },
          "summary": {
            "title": "Résumé de l'enchère",
            "startPrice": "Prix de départ",
            "minBid": "Pas minimum"
          },
          "startAuction": "Lancer l'enchère",
          "starting": "Lancement..."
        },
        "auction": {
          "success": "L'enchère a été lancée avec succès pour une durée de {{time}} heure{{plural}}.",
          "error": "Impossible de lancer l'enchère. Veuillez réessayer.",
          "invalidData": "Données invalides. Veuillez vérifier les informations saisies.",
          "productNotFound": "Le produit n'existe plus.",
          "timeout": "La requête a expiré. Vérifiez votre connexion internet.",
          "stop": {
            "title": "Arrêter l'enchère",
            "message": "Êtes-vous sûr de vouloir arrêter cette enchère ? Cette action mettra fin immédiatement à toutes les offres en cours.",
            "button": "Arrêter l'enchère",
            "success": "L'enchère a été arrêtée avec succès.",
            "error": "Impossible d'arrêter l'enchère. Veuillez réessayer."
          }
        },
        "delete": {
          "confirmTitle": "Confirmer la suppression",
          "confirmMessage": "Êtes-vous sûr de vouloir supprimer définitivement ce produit ? Cette action est irréversible.",
          "deleteButton": "Supprimer",
          "success": "Le produit a été supprimé avec succès.",
          "error": "Impossible de supprimer le produit. Veuillez réessayer.",
          "notFound": "Le produit n'existe plus.",
          "unauthorized": "Vous n'êtes pas autorisé à supprimer ce produit."
        },
        "markSold": {
          "title": "Marquer comme vendu",
          "message": "Ce produit a-t-il été vendu ? Cette action le retirera des annonces actives.",
          "button": "Marquer vendu",
          "success": "Le produit a été marqué comme vendu.",
          "error": "Impossible de marquer comme vendu. Veuillez réessayer."
        },
        "refresh": {
          "title": "Tirer pour actualiser"
        },
        "footer": {
          "loadMore": "Charger plus de produits",
          "pageInfo": "Page {{current}} sur {{total}}",
          "searchResults": "{{count}} produit{{plural}} trouvé{{plural}}",
          "allProducts": "Tous vos produits sont affichés",
          "addNewProduct": "Ajouter un nouveau produit"
        },
        "emptyScreen": {
          "title": "Aucun produit pour le moment",
          "description": "Commencez par créer votre première annonce pour vendre vos produits.",
          "createFirstAd": "Créer ma première annonce"
        },
        "emptySearch": {
          "title": "Aucun résultat trouvé",
          "description": "Aucun produit ne correspond à \"{{query}}\"",
          "clear": "Effacer la recherche"
        },
        "errorScreen": {
          "title": "Oups ! Une erreur est survenue",
          "retry": "Réessayer",
          "back": "Retour"
        },
        "Acceuil": "Accueil",
        "Shop": "Boutique",
        "Vendre": "Vendre",
        "Enchères": "Enchères",
        "Profile": "Profil",
        "profileHeader": {
          "welcome": "Bonjour 👋",
          "personalTitle": "Gérez votre espace personnel",
          "status": {
            "pro": "Professionnel vérifié",
            "verified": "Compte vérifié"
          },
          "proCard": {
            "title": "Passez Professionnel",
            "description": "Augmentez votre visibilité, recevez plus de demandes et gérez votre activité efficacement.",
            "benefits": {
              "verified": "Profil vérifié",
              "visibility": "Plus de visibilité",
              "tools": "Outils de gestion"
            }
          },
          "contact": {
            "call": "Appeler",
            "locate": "Localiser",
            "email": "Email",
            "website": "Site web"
          },
          "infoSections": {
            "about": "À propos",
            "specialties": "Spécialités",
            "hours": "Horaires"
          },
          "buttons": {
            "editPro": "Modifier le profil pro",
            "becomePro": "Devenir Professionnel",
            "save": "Enregistrer",
            "cancel": "Annuler",
            "activate": "Activer le profil"
          },
          "modal": {
            "editTitle": "Modifier le profil pro",
            "editSubtitle": "Mettez à jour vos informations",
            "becomeTitle": "Devenir Professionnel",
            "becomeSubtitle": "Augmentez votre visibilité",
            "activityType": "Type d'activité",
            "activityDescription": "Sélectionnez votre domaine d'activité principal",
            "basicInfo": "Informations de base",
            "presentation": "Présentation",
            "companyName": "Nom de l'entreprise",
            "address": "Adresse",
            "phone": "Téléphone",
            "email": "Email",
            "website": "Site web",
            "description": "Description",
            "descriptionPlaceholder": "Décrivez votre entreprise et vos services...",
            "specialties": "Spécialités",
            "specialtiesPlaceholder": "Ex: Mécanique, Carrosserie, Peinture...",
            "hours": "Horaires d'ouverture",
            "hoursPlaceholder": "Ex: Lundi-Vendredi 8h-18h, Samedi 8h-13h",
            "infoNote": "Vos modifications seront visibles immédiatement par vos clients.",
            "charCount": "caractères",
            "loading": "Chargement..."
          },
          "validation": {
            "companyRequired": "Veuillez saisir le nom de votre entreprise",
            "addressRequired": "Veuillez saisir l'adresse de votre entreprise",
            "phoneRequired": "Veuillez saisir un numéro de téléphone professionnel"
          },
          "messages": {
            "updateSuccess": "✓ Informations professionnelles mises à jour",
            "activationSuccess": "🎉 Profil professionnel activé avec succès",
            "congratulations": "Félicitations !",
            "activationMessage": "Votre profil professionnel est maintenant actif.\nVous bénéficiez maintenant de toutes les fonctionnalités pro.",
            "super": "Super !",
            "error": "Une erreur est survenue. Veuillez réessayer.",
            "updatingData": "Mise à jour des données...",
            "refreshData": "Rafraîchir les données..."
          },
          "activityTypes": {
            "Service Locations auto/moto": "Service Locations auto/moto",
            "Service Lavage auto/moto": "Service Lavage auto/moto",
            "Service Auto/moto école": "Service Auto/moto école",
            "Service Garage/mécanique": "Service Garage/mécanique",
            "Service Visite technique": "Service Visite technique",
            "Service Entretien (vidange/huile)": "Service Entretien (vidange/huile)",
            "Service Carrosserie/Peinture": "Service Carrosserie/Peinture",
            "Service Assurance auto/moto": "Service Assurance auto/moto",
            "Service Vente auto/moto": "Service Vente auto/moto",
            "Service Vente de pièces": "Service Vente de pièces"
          },
          "defaults": {
            "autoProfessional": "Professionnel auto/moto",
            "contact": "Contact",
            "about": "À propos"
          }
        },
        "userProfile": {
          "title": "Profil Utilisateur",
          "tabs": {
            "overview": "Aperçu",
            "products": "Articles",
            "verification": "Vérification",
            "privacy": "Confidentialité"
          },
          "profileHeader": {
            "noLocation": "Localisation non spécifiée",
            "noEmail": "Non spécifié",
            "stats": {
              "listings": "Annonces",
              "sales": "Ventes",
              "response": "Réponse"
            },
            "updateSuccess": "Profil mis à jour avec succès",
            "updateError": "Erreur lors de la mise à jour du profil"
          },
          "editModal": {
            "title": "Modifier le profil",
            "profilePicture": "Photo de profil",
            "noPhoto": "Aucune photo",
            "helpText": "Choisissez une photo pour votre profil (max 5MB)",
            "gallery": "Galerie",
            "camera": "Caméra",
            "remove": "Supprimer",
            "personalInfo": "Informations personnelles",
            "fullName": "Nom complet *",
            "fullNamePlaceholder": "Votre nom complet",
            "email": "Email *",
            "emailPlaceholder": "votre@email.com",
            "phone": "Téléphone",
            "phonePlaceholder": "Votre numéro de téléphone",
            "address": "Adresse",
            "addressPlaceholder": "Votre adresse complète",
            "changePassword": "Changer le mot de passe",
            "passwordNote": "Laissez vide pour ne pas modifier",
            "currentPassword": "Mot de passe actuel",
            "currentPasswordPlaceholder": "Mot de passe actuel",
            "newPassword": "Nouveau mot de passe",
            "newPasswordPlaceholder": "Nouveau mot de passe",
            "confirmPassword": "Confirmer le mot de passe",
            "confirmPasswordPlaceholder": "Confirmer le nouveau mot de passe",
            "cancel": "Annuler",
            "save": "Enregistrer",
            "uploading": "Téléchargement...",
            "saving": "Enregistrement..."
          },
          "validation": {
            "nameRequired": "Le nom est requis",
            "emailRequired": "L'email est requis",
            "invalidEmail": "Email invalide",
            "invalidPhone": "Numéro de téléphone invalide",
            "currentPasswordRequired": "Le mot de passe actuel est requis",
            "passwordMinLength": "Minimum 6 caractères",
            "passwordMismatch": "Les mots de passe ne correspondent pas",
            "formErrors": "Veuillez corriger les erreurs dans le formulaire"
          },
          "alerts": {
            "error": "Erreur",
            "success": "Succès",
            "removePhoto": "Supprimer la photo",
            "removePhotoConfirm": "Voulez-vous vraiment supprimer votre photo de profil ?",
            "cancel": "Annuler",
            "remove": "Supprimer",
            "imageError": "Impossible de sélectionner l'image",
            "cameraError": "Impossible de prendre la photo",
            "uploadError": "Erreur lors du téléchargement de l'image",
            "invalidImage": "Format d'image invalide",
            "imageTooLarge": "L'image est trop grande (max 5MB)",
            "emailInUse": "Cet email est déjà utilisé par un autre compte",
            "sessionExpired": "Session expirée. Veuillez vous reconnecter."
          },
          "loading": {
            "loadingProfile": "Chargement de votre profil...",
            "refreshing": "Mise à jour..."
          },
          "userTypes": {
            "garage": "Service Garage/mécanique",
            "user": "Utilisateur"
          },
          "status": {
            "verified": "Vérifié",
            "pro": "PRO"
          },
          "emptyFields": {
            "user": "Utilisateur",
            "location": "Localisation non spécifiée"
          }
        },
        "auctions": {
          "title": "Enchères en cours",
          "subtitle": {
            "active": "active",
            "active_plural": "actives",
            "total": "au total"
          },
          "stats": {
            "active": "Actives",
            "expiringSoon": "Se terminent bientôt",
            "total": "Total",
            "ended": "Terminées"
          },
          "auctionCard": {
            "auction": "ENCHÈRE",
            "ended": "TERMINÉ",
            "expired": "Terminé",
            "time": {
              "days": "j",
              "hours": "h",
              "minutes": "m",
              "seconds": "s"
            },
            "location": "Localisation non précisée",
            "currentPrice": "PRIX ACTUEL",
            "startingPrice": "PRIX DÉPART",
            "placeBid": "Faire offre",
            "viewDetails": "Voir détails",
            "makeOffer": "Faire offre",
            "noPhotos": "Pas de photos"
          },
          "emptyState": {
            "title": "Aucune enchère disponible",
            "message": "Il n'y a pas d'enchères actives pour le moment. Revenez plus tard pour découvrir de nouvelles opportunités.",
            "refresh": "Actualiser"
          },
          "loading": "Chargement des enchères...",
          "timeLeft": {
            "days": "jours",
            "hours": "heures",
            "minutes": "minutes",
            "seconds": "secondes",
            "expired": "Terminé",
            "urgent": "Se termine bientôt",
            "endingToday": "Se termine aujourd'hui"
          }
        },
        "shop": {
          "title": "BOUTIQUE",
          "subtitle": {
            "products": "produit disponible",
            "products_plural": "produits disponibles"
          },
          "searchPlaceholder": "Rechercher un produit, marque, modèle...",
          "quickSearch": {
            "porsche": "Porsche",
            "jeep": "Jeep",
            "new": "Neuf",
            "auction": "Enchère"
          },
          "productCard": {
            "state": "État",
            "auction": "Enchère",
            "negotiable": "Négociable",
            "exchange": "Échange",
            "warranty": "Garantie",
            "viewDetails": "Voir détails",
            "unknownLocation": "Localisation non précisée",
            "seller": "Vendeur",
            "garage": "Garage",
            "mechanic": "Mécanicien",
            "professional": "Professionnel",
            "private": "Particulier",
            "new": "Neuf",
            "likeNew": "Comme neuf",
            "used": "Occasion"
          },
          "emptyState": {
            "title": "Aucun résultat",
            "message": "Aucun produit ne correspond à votre recherche",
            "showAll": "Afficher tous les produits",
            "alert": "Mettre en alerte",
            "alertMessage": "Activez une alerte sur ce produit pendant 1 mois pour seulement 500 FCFA."
          },
          "footer": {
            "allProducts": "Vous avez vu tous les {count} produits",
            "searchResults": "{count} produit correspond à votre recherche",
            "searchResults_plural": "{count} produits correspondent à votre recherche"
          },
          "loading": "Chargement des produits...",
          "filters": {
            "all": "Tous",
            "new": "Neuf",
            "used": "Occasion",
            "auction": "Enchère",
            "negotiable": "Négociable"
          },
          "sort": {
            "recent": "Plus récents",
            "priceLow": "Prix : Croissant",
            "priceHigh": "Prix : Décroissant",
            "distance": "Distance"
          }
        },
        "services": {
          "title": "Services Pro",
          "subtitle": "Services triés par distance",
          "subtitleNoLocation": "Activez la localisation pour voir les distances",
          "activeUsers": "Utilisateurs Actifs",
          "availableParts": "Pièces Disponibles",
          "coverage": "Couverture",
          "verifiedServices": "Services Vérifiés",
          "searchPlaceholder": "Rechercher un service...",
          "allServices": "Tous les Services",
          "centers": "Centres",
          "garages": "Garages",
          "pro": "PRO",
          "locationPermission": {
            "title": "Permission de localisation",
            "message": "L'application a besoin d'accéder à votre position pour calculer les distances.",
            "iosError": "Erreur de permission iOS",
            "androidError": "Erreur de permission Android",
            "denied": "Permission de localisation refusée",
            "unable": "Impossible d'obtenir la position"
          },
          "filters": {
            "nearMe": "Près de moi",
            "withAvailability": "Avec disponibilité",
            "verifiedOnly": "Vérifiés uniquement",
            "openNow": "Ouverts maintenant"
          },
          "status": {
            "open": "Ouvert",
            "closed": "Fermé",
            "openingHours": "Horaires d'ouverture",
            "waitTime": "Temps d'attente"
          },
          "stats": {
            "usersCount": "Professionnels actifs",
            "partsCount": "Pièces disponibles",
            "regionsCount": "Régions couvertes",
            "verifiedCount": "Services vérifiés"
          },
          "serviceTypes": {
            "center": "Centre",
            "garage": "Garage",
            "mechanical": "Mécanique",
            "technicalInspection": "Visite technique"
          },
          "features": {
            "professional": "Professionnel",
            "certified": "Certifié",
            "localService": "Service local",
            "repair": "Réparation",
            "maintenance": "Entretien",
            "parts": "Pièces"
          },
          "buttons": {
            "call": "Appeler",
            "whatsapp": "WhatsApp",
            "details": "Détails",
            "retry": "Réessayer",
            "refresh": "Actualiser",
            "enableLocation": "Activer la localisation"
          },
          "messages": {
            "loading": "Chargement des services...",
            "locationDetected": "Position détectée ✓",
            "noServices": "Aucun service disponible",
            "noProServices": "Aucun service PRO disponible",
            "noMatch": "Aucun service ne correspond à vos critères",
            "phoneUnavailable": "Numéro de téléphone non disponible",
            "whatsappUnavailable": "Numéro WhatsApp non disponible",
            "callService": "Appeler le service",
            "confirmCall": "Voulez-vous appeler",
            "cancel": "Annuler",
            "call": "Appeler",
            "whatsappNotInstalled": "WhatsApp n'est pas installé",
            "phoneAppError": "Impossible d'ouvrir l'application téléphone"
          },
          "emptyStates": {
            "noServices": "Aucun service n'a été trouvé pour le moment",
            "noResults": "Aucun service ne correspond à vos critères de recherche",
            "enableFilters": "Essayez de modifier votre recherche ou vos filtres"
          },
          "distance": "km",
          "reviews": "avis",
          "unknownCity": "Ville inconnue",
          "unknownAddress": "Adresse non précisée",
          "categories": {
            "mechanical": "Mécanique",
            "inspection": "Visite technique",
            "repair": "Réparation",
            "maintenance": "Entretien"
          }
        },
        "trustSignals": {
          "sectionTitle": "Sécurité & Confiance",
          "sectionSubtitle": "Nous mettons tout en œuvre pour garantir des transactions sécurisées et transparentes",
          "whyTrustUs": "Pourquoi nous faire confiance ?",
          "joinCommunity": "Rejoignez notre communauté grandissante de passionnés d'automobile",
          "userTestimonials": "Ce que disent nos utilisateurs",
          "realExperiences": "Des expériences réelles de notre communauté",
          "securePayments": "Paiements Sécurisés",
          "paymentOptions": "Plusieurs options de paiement adaptées au Cameroun",
          "joinCommunityCTA": "Rejoindre la communauté",
          "createAccount": "Créez votre compte en moins de 2 minutes",
          "allTransactions": "Toutes les transactions sont chiffrées et sécurisées",
          "activeUsers": "Utilisateurs Actifs",
          "partsAvailable": "Pièces Disponibles",
          "regionsCovered": "Régions Couvertes",
          "averageRating": "Note Moyenne",
          "stats": {
            "verifiedUsers": "Vendeurs et acheteurs vérifiés",
            "newUsedParts": "Neuves et d'occasion",
            "countrywide": "Partout au Cameroun",
            "customerSatisfaction": "Satisfaction client"
          },
          "securityFeatures": {
            "identityVerification": {
              "title": "Vérification d'Identité",
              "description": "Validation optionnelle avec photo et document d'identité"
            },
            "fraudProtection": {
              "title": "Protection Anti-Fraude",
              "description": "Messages d'avertissement et signalement des activités suspectes"
            },
            "certifiedSellers": {
              "title": "Vendeurs Certifiés",
              "description": "Badges professionnels pour les vendeurs vérifiés"
            },
            "secureCommunication": {
              "title": "Communication Sécurisée",
              "description": "Intégration WhatsApp pour des échanges transparents"
            }
          },
          "paymentMethods": {
            "orangeMoney": "Orange Money",
            "mtnMobileMoney": "MTN Mobile Money"
          },
          "seller": "Vendeur",
          "buyer": "Acheteur",
          "professionalBadges": "Badges professionnels",
          "transparentExchanges": "Échanges transparents"
        },
        "recentListings": {
          "sectionTitle": "Dernières Annonces",
          "sectionSubtitle": "Les dernières pièces et véhicules ajoutés sur la plateforme",
          "viewAll": "Voir toutes les annonces",
          "loadMore": "Charger plus d'annonces",
          "new": "Nouveau",
          "negotiable": "Négociable",
          "exchange": "Échange",
          "loading": "Chargement des annonces...",
          "retry": "Réessayer",
          "noListings": "Aucune annonce disponible",
          "addListing": "Ajouter une annonce",
          "errorLoading": "Erreur de chargement des annonces",
          "justNow": "À l'instant",
          "minutesAgo": " min",
          "hoursAgo": "h",
          "daysAgo": "j",
          "conditions": {
            "new": "Neuf",
            "likeNew": "Comme neuf",
            "used": "Occasion",
            "goodCondition": "Bon état",
            "excellentCondition": "Excellent état"
          }
        },
        "Catégories": "Catégories",
        "Pièces et accessoires moto": "Pièces et accessoires moto",
        "Motorcycle parts & accessories": "Pièces et accessoires moto",
        "Moteurs et composants": "Moteurs et composants",
        "Engines and components": "Moteurs et composants",
        "Œuvres d'art uniques": "Œuvres d'art uniques",
        "Unique artworks": "Œuvres d'art uniques",
        "Pièces automobile complètes": "Pièces automobile complètes",
        "Complete auto parts": "Pièces automobile complètes",
        "Carrosserie et peinture": "Carrosserie et peinture",
        "Bodywork and paint": "Carrosserie et peinture",
        "Systèmes de freinage": "Systèmes de freinage",
        "Suspensions et amortisseurs": "Suspensions et amortisseurs",
        "Transmissions et boîtes": "Transmissions et boîtes",
        "Transmissions and gearboxes": "Transmissions et boîtes",
        "Systèmes d'échappement": "Systèmes d'échappement",
        "Produits de qualité": "Produits de qualité",
        "Quality products": "Produits de qualité",
        "Impossible de charger les catégories. Vérifiez votre connexion.": "Impossible de charger les catégories. Vérifiez votre connexion.",
        "Unable to load categories. Check your connection.": "Impossible de charger les catégories. Vérifiez votre connexion.",
        "Format de réponse API invalide": "Format de réponse API invalide",
        "Invalid API response format": "Format de réponse API invalide",
        "Error fetching categories:": "Erreur lors du chargement des catégories:",
        "Error loading language preference:": "Erreur lors du chargement des préférences de langue:",
        "Populaire": "Populaire",
        "Popular": "Populaire",
        "Motorcycle Parts": "Pièces Moto",
        "Engines": "Moteurs",
        "Bodywork": "Carrosserie",
        "Freins": "Freins",
        "Brakes": "Freins",
        "Accessoires et pièces détachées": "Accessoires et pièces détachées",
        "Accessories and spare parts": "Accessoires et pièces détachées",
        "Moteurs complets et pièces": "Moteurs complets et pièces",
        "Complete engines and parts": "Moteurs complets et pièces",
        "Pièces de carrosserie auto": "Pièces de carrosserie auto",
        "Auto body parts": "Pièces de carrosserie auto",
        "Braking systems": "Systèmes de freinage",
        "Catégorie du Produit *": "Catégorie du Produit *",
        "Product Category *": "Catégorie du Produit *",
        "Sous-catégorie": "Sous-catégorie",
        "Subcategory": "Sous-catégorie",
        "Marques Compatibles (Optionnel)": "Marques Compatibles (Optionnel)",
        "Compatible Brands (Optional)": "Marques Compatibles (Optionnel)",
        "Détails du Véhicule *": "Détails du Véhicule *",
        "Vehicle Details *": "Détails du Véhicule *",
        "État du Produit *": "État du Produit *",
        "Product Condition *": "État du Produit *",
        "Détails Supplémentaires (Optionnel)": "Détails Supplémentaires (Optionnel)",
        "Additional Details (Optional)": "Détails Supplémentaires (Optionnel)",
        "Catégorie actuelle (non modifiable)": "Catégorie actuelle (non modifiable)",
        "Current category (cannot be modified)": "Catégorie actuelle (non modifiable)",
        "Choisissez la catégorie principale de votre annonce": "Choisissez la catégorie principale de votre annonce",
        "Choose the main category of your ad": "Choisissez la catégorie principale de votre annonce",
        "Précisez le type exact de produit (optionnel)": "Précisez le type exact de produit (optionnel)",
        "Specify the exact product type (optional)": "Précisez le type exact de produit (optionnel)",
        "Sélectionnez les marques de véhicules compatibles": "Sélectionnez les marques de véhicules compatibles",
        "Select compatible vehicle brands": "Sélectionnez les marques de véhicules compatibles",
        "Décrivez honnêtement l'état de votre article": "Décrivez honnêtement l'état de votre article",
        "Describe honestly the condition of your item": "Décrivez honnêtement l'état de votre article",
        "Marque du Véhicule *": "Marque du Véhicule *",
        "Vehicle Brand *": "Marque du Véhicule *",
        "Modèle *": "Modèle *",
        "Model *": "Modèle *",
        "Année *": "Année *",
        "Year *": "Année *",
        "Kilométrage (km) (Optionnel)": "Kilométrage (km) (Optionnel)",
        "Mileage (km) (Optional)": "Kilométrage (km) (Optionnel)",
        "Numéro de Pièce/Référence": "Numéro de Pièce/Référence",
        "Part Number/Reference": "Numéro de Pièce/Référence",
        "Garantie": "Garantie",
        "Warranty": "Garantie",
        "Sélectionner une catégorie": "Sélectionner une catégorie",
        "Select a category": "Sélectionner une catégorie",
        "Sélectionner une sous-catégorie": "Sélectionner une sous-catégorie",
        "Select a subcategory": "Sélectionner une sous-catégorie",
        "Sélectionner l'état": "Sélectionner l'état",
        "Select condition": "Sélectionner l'état",
        "Sélectionner une marque": "Sélectionner une marque",
        "Select a brand": "Sélectionner une marque",
        "ex: Camry, Civic, C3": "ex: Camry, Civic, C3",
        "ex: 2015": "ex: 2015",
        "ex: 150000": "ex: 150000",
        "ex: 12345-67890, OEM-REF-001": "ex: 12345-67890, OEM-REF-001",
        "ex: 6 mois, 1 an, Aucune": "ex: 6 mois, 1 an, Aucune",
        "Numéro OEM ou référence constructeur": "Numéro OEM ou référence constructeur",
        "OEM number or manufacturer reference": "Numéro OEM ou référence constructeur",
        "Durée de garantie offerte": "Durée de garantie offerte",
        "Warranty duration offered": "Durée de garantie offerte",
        "catégorie(s) disponible(s)": "catégorie(s) disponible(s)",
        "category(ies) available": "catégorie(s) disponible(s)",
        "sous-catégorie(s) disponible(s)": "sous-catégorie(s) disponible(s)",
        "subcategory(ies) available": "sous-catégorie(s) disponible(s)",
        "état(s) disponible(s)": "état(s) disponible(s)",
        "condition(s) available": "état(s) disponible(s)",
        "marque(s) disponible(s)": "marque(s) disponible(s)",
        "brand(s) available": "marque(s) disponible(s)",
        "Rechercher une catégorie...": "Rechercher une catégorie...",
        "Search for a category...": "Rechercher une catégorie...",
        "Rechercher une sous-catégorie...": "Rechercher une sous-catégorie...",
        "Search for a subcategory...": "Rechercher une sous-catégorie...",
        "Rechercher un état...": "Rechercher un état...",
        "Search for a condition...": "Rechercher un état...",
        "Rechercher une marque...": "Rechercher une marque...",
        "Search for a brand...": "Rechercher une marque...",
        "Impossible de charger les catégories": "Impossible de charger les catégories",
        "Unable to load categories": "Impossible de charger les catégories",
        "Service catégories non disponible": "Service catégories non disponible",
        "Category service unavailable": "Service catégories non disponible",
        "Erreur serveur. Veuillez réessayer plus tard.": "Erreur serveur. Veuillez réessayer plus tard.",
        "Server error. Please try again later.": "Erreur serveur. Veuillez réessayer plus tard.",
        "Impossible de se connecter au serveur. Vérifiez votre connexion.": "Impossible de se connecter au serveur. Vérifiez votre connexion.",
        "Unable to connect to server. Check your connection.": "Impossible de se connecter au serveur. Vérifiez votre connexion.",
        "Format de données invalide": "Format de données invalide",
        "Invalid data format": "Format de données invalide",
        "Erreur lors du chargement des catégories:": "Erreur lors du chargement des catégories:",
        "Error loading categories:": "Erreur lors du chargement des catégories:",
        "Erreur lors du chargement des sous-catégories:": "Erreur lors du chargement des sous-catégories:",
        "Error loading subcategories:": "Erreur lors du chargement des sous-catégories:",
        "Chargement des sous-catégories...": "Chargement des sous-catégories...",
        "Loading subcategories...": "Chargement des sous-catégories...",
        "Aucune catégorie trouvée": "Aucune catégorie trouvée",
        "No category found": "Aucune catégorie trouvée",
        "Aucune sous-catégorie disponible": "Aucune sous-catégorie disponible",
        "No subcategory available": "Aucune sous-catégorie disponible",
        "Essayez avec un autre terme de recherche": "Essayez avec un autre terme de recherche",
        "Try with another search term": "Essayez avec un autre terme de recherche",
        "Aucune sous-catégorie pour cette catégorie": "Aucune sous-catégorie pour cette catégorie",
        "No subcategory for this category": "Aucune sous-catégorie pour cette catégorie",
        "Essayez avec un autre terme": "Essayez avec un autre terme",
        "Try with another term": "Essayez avec un autre terme",
        "⟳ Réessayer": "⟳ Réessayer",
        "⟳ Retry": "⟳ Réessayer",
        "Neuf": "Neuf",
        "New": "Neuf",
        "Comme Neuf": "Comme Neuf",
        "Like New": "Comme Neuf",
        "Bon État": "Bon État",
        "Good Condition": "Bon État",
        "État Correct": "État Correct",
        "Fair Condition": "État Correct",
        "Mauvais État": "Mauvais État",
        "Poor Condition": "Mauvais État",
        "Pour Pièces Uniquement": "Pour Pièces Uniquement",
        "For Parts Only": "Pour Pièces Uniquement",
        "Toyota": "Toyota",
        "Honda": "Honda",
        "Nissan": "Nissan",
        "Mercedes-Benz": "Mercedes-Benz",
        "BMW": "BMW",
        "Volkswagen": "Volkswagen",
        "Peugeot": "Peugeot",
        "Renault": "Renault",
        "Hyundai": "Hyundai",
        "Kia": "Kia",
        "Ford": "Ford",
        "Chevrolet": "Chevrolet",
        "Audi": "Audi",
        "Mazda": "Mazda",
        "Suzuki": "Suzuki",
        "Mitsubishi": "Mitsubishi",
        "Subaru": "Subaru",
        "Lexus": "Lexus",
        "Jeep": "Jeep",
        "Land Rover": "Land Rover",
        "Pièces Auto": "Pièces Auto",
        "Pièces Moto": "Pièces Moto",
        "Moteurs": "Moteurs",
        "Véhicules Complets": "Véhicules Complets",
        "Pièces détachées pour automobiles": "Pièces détachées pour automobiles",
        "Spare parts for automobiles": "Pièces détachées pour automobiles",
        "Pièces détachées pour motos": "Pièces détachées pour motos",
        "Spare parts for motorcycles": "Pièces détachées pour motos",
        "Moteurs complets et pièces moteur": "Moteurs complets et pièces moteur",
        "Complete engines and engine parts": "Moteurs complets et pièces moteur",
        "Pièces de carrosserie et tôlerie": "Pièces de carrosserie et tôlerie",
        "Bodywork and sheet metal parts": "Pièces de carrosserie et tôlerie",
        "Véhicules complets à vendre": "Véhicules complets à vendre",
        "Complete vehicles for sale": "Véhicules complets à vendre",
        "Erreur de chargement": "Erreur de chargement",
        "Loading error": "Erreur de chargement",
        "Réessayer": "Réessayer",
        "Retry": "Réessayer",
        "Détection de votre pays...": "Détection de votre pays...",
        "Detecting your country...": "Détection de votre pays...",
        "Trouvez vos pièces auto au": "Trouvez vos pièces auto - ",
        "Find Auto Parts in": "Trouvez vos pièces auto au",
        "Trouvez vos pièces auto": "Trouvez vos pièces auto",
        "Marketplace de pièces automobiles neuves et d'occasion, véhicules complets et services auto": "Marketplace de pièces automobiles neuves et d'occasion, véhicules complets et services auto",
        "Marketplace for new and used automotive parts, complete vehicles and auto services": "Marketplace de pièces automobiles neuves et d'occasion, véhicules complets et services auto",
        "Rechercher pièces, marques, modèles...": "Rechercher pièces, marques, modèles...",
        "Search parts, brands, models...": "Rechercher pièces, marques, modèles...",
        "Rechercher": "Rechercher",
        "Search": "Rechercher",
        "Recherche vocale": "Recherche vocale",
        "Voice Search": "Recherche vocale",
        "Recherche avancée": "Recherche avancée",
        "Advanced Search": "Recherche avancée",
        "Simulation d'enregistrement...": "Simulation d'enregistrement...",
        "Recording simulation...": "Simulation d'enregistrement...",
        "Simulation de traitement en cours...": "Simulation de traitement en cours...",
        "Processing simulation...": "Simulation de traitement en cours...",
        "Appuyez sur le bouton pour simuler la reconnaissance vocale": "Appuyez sur le bouton pour simuler la reconnaissance vocale",
        "Press the button to simulate voice recognition": "Appuyez sur le bouton pour simuler la reconnaissance vocale",
        "Texte simulé:": "Texte simulé:",
        "Simulated text:": "Texte simulé:",
        "Exemples simulés:": "Exemples simulés:",
        "Simulated examples:": "Exemples simulés:",
        "Ceci est une simulation. Le texte est généré aléatoirement.": "Ceci est une simulation. Le texte est généré aléatoirement.",
        "This is a simulation. Text is randomly generated.": "Ceci est une simulation. Le texte est généré aléatoirement.",
        "Démarrer la simulation": "Démarrer la simulation",
        "Start simulation": "Démarrer la simulation",
        "Arrêter": "Arrêter",
        "Stop": "Arrêter",
        "Utiliser le texte": "Utiliser le texte",
        "Use text": "Utiliser le texte",
        "Aucun texte": "Aucun texte",
        "No text": "Aucun texte",
        "Veuillez d'abord enregistrer une recherche vocale": "Veuillez d'abord enregistrer une recherche vocale",
        "Please record a voice search first": "Veuillez d'abord enregistrer une recherche vocale",
        "Permission de localisation": "Permission de localisation",
        "Location Permission": "Permission de localisation",
        "Cette application a besoin d'accéder à votre localisation pour afficher les pièces auto disponibles dans votre pays.": "Cette application a besoin d'accéder à votre localisation pour afficher les pièces auto disponibles dans votre pays.",
        "This app needs access to your location to show auto parts available in your country.": "Cette application a besoin d'accéder à votre localisation pour afficher les pièces auto disponibles dans votre pays.",
        "Demander plus tard": "Demander plus tard",
        "Ask Later": "Demander plus tard",
        "Cancel": "Annuler",
        "OK": "OK",
        "pneus Toyota": "pneus Toyota",
        "moteur Peugeot 206": "moteur Peugeot 206",
        "freins avant": "freins avant",
        "phare Audi A4": "phare Audi A4",
        "pare-chocs Renault": "pare-chocs Renault",
        "batterie voiture": "batterie voiture",
        "amortisseurs neufs": "amortisseurs neufs",
        "volant Mercedes": "volant Mercedes",
        "sièges en cuir": "sièges en cuir",
        "klaxon camion": "klaxon camion",
        "Toyota tires": "pneus Toyota",
        "Peugeot 206 engine": "moteur Peugeot 206",
        "front brakes": "freins avant",
        "Audi A4 headlight": "phare Audi A4",
        "Renault bumper": "pare-chocs Renault",
        "car battery": "batterie voiture",
        "new shock absorbers": "amortisseurs neufs",
        "Mercedes steering wheel": "volant Mercedes",
        "leather seats": "sièges en cuir",
        "truck horn": "klaxon camion",
        "Confidentialité & Paramètres": "Confidentialité & Paramètres",
        "Contrôlez la visibilité de votre profil et vos préférences de communication": "Contrôlez la visibilité de votre profil et vos préférences de communication",
        "Préférences de Langue": "Préférences de Langue",
        "Langue de l'interface": "Langue de l'interface",
        "Choisissez votre langue préférée pour l'interface de l'application": "Choisissez votre langue préférée pour l'interface de l'application",
        "Français": "Français",
        "English": "Anglais",
        "Paramètres de Notification": "Paramètres de Notification",
        "Notifications par email": "Notifications par email",
        "Recevoir des mises à jour importantes par email": "Recevoir des mises à jour importantes par email",
        "Notifications SMS": "Notifications SMS",
        "Recevoir des notifications urgentes par SMS": "Recevoir des notifications urgentes par SMS",
        "Notifications WhatsApp": "Notifications WhatsApp",
        "Recevoir des notifications sur WhatsApp": "Recevoir des notifications sur WhatsApp",
        "Données & Confidentialité": "Données & Confidentialité",
        "Autoriser l'analyse des données": "Autoriser l'analyse des données",
        "Aidez à améliorer la plateforme en partageant des données d'utilisation anonymes": "Aidez à améliorer la plateforme en partageant des données d'utilisation anonymes",
        "Rcommandations personnalisées": "Recommandations personnalisées",
        "Afficher des recommandations de pièces personnalisées basées sur votre activité": "Afficher des recommandations de pièces personnalisées basées sur votre activité",
        "Sécurité du Compte": "Sécurité du Compte",
        "Notifications de connexion": "Notifications de connexion",
        "Soyez informé lorsque quelqu'un se connecte à votre compte": "Soyez informé lorsque quelqu'un se connecte à votre compte",
        "Gestion des Données": "Gestion des Données",
        "Se deconnecter": "Se déconnecter",
        "Supprimer le Compte": "Supprimer le Compte",
        "La suppression du compte est permanente et ne peut pas être annulée. Toutes vos annonces et données seront supprimées.": "La suppression du compte est permanente et ne peut pas être annulée. Toutes vos annonces et données seront supprimées.",
        "Public - Visible par tous": "Public - Visible par tous",
        "Utilisateurs Vérifiés Uniquement": "Utilisateurs Vérifiés Uniquement",
        "Privé - Caché des autres": "Privé - Caché des autres",
        "WhatsApp uniquement": "WhatsApp uniquement",
        "Appels téléphoniques uniquement": "Appels téléphoniques uniquement",
        "WhatsApp & Téléphone": "WhatsApp & Téléphone",
        "Pas de contact direct": "Pas de contact direct",
        "Sauvegarder": "Sauvegarder",
        "Réinitialiser": "Réinitialiser",
        "Exporter les Données": "Exporter les Données",
        "Supprimer": "Supprimer",
        "Annuler": "Annuler",
        "Oui": "Oui",
        "Succès": "Succès",
        "Erreur": "Erreur",
        "Paramètres sauvegardés avec succès": "Paramètres sauvegardés avec succès",
        "Paramètres restaurés": "Paramètres restaurés",
        "Fonctionnalité bientôt disponible": "Fonctionnalité bientôt disponible",
        "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.": "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.",
        "Compte Supprimé": "Compte Supprimé",
        "Votre compte a été supprimé": "Votre compte a été supprimé",
        "error": "Erreur"
      }
    }
  };

  // Fonction pour récupérer la langue sauvegardée (utilise localStorage au lieu de AsyncStorage)
  const getSavedLanguage = () => {
    try {
      const savedLanguage = localStorage.getItem('Langue');
      return savedLanguage || 'fr'; // Par défaut français
    } catch (error) {
      console.error('Error loading language:', error);
      return 'fr';
    }
  };

  // Fonction pour initialiser i18n
  export const initI18n = async () => {
    try {
      const savedLanguage = getSavedLanguage();
      
      await i18n
        .use(LanguageDetector) // Détection automatique de la langue du navigateur
        .use(initReactI18next)
        .init({
          resources,
          lng: savedLanguage,
          fallbackLng: 'en',
          interpolation: {
            escapeValue: false // React s'occupe déjà de l'échappement
          },
          react: {
            useSuspense: true // Activer Suspense pour React
          },
          detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage']
          }
        });
      
      console.log('i18n initialized with language:', i18n.language);
      return i18n;
    } catch (error) {
      console.error('Error initializing i18n:', error);
      // Initialisation par défaut en cas d'erreur
      await i18n
        .use(initReactI18next)
        .init({
          resources,
          lng: 'fr',
          fallbackLng: 'en',
          interpolation: {
            escapeValue: false
          },
          react: {
            useSuspense: true
          }
        });
      return i18n;
    }
  };

  // Fonction utilitaire pour changer de langue
  export const changeLanguage = (lng) => {
    try {
      i18n.changeLanguage(lng);
      localStorage.setItem('Langue', lng);
      return true;
    } catch (error) {
      console.error('Error changing language:', error);
      return false;
    }
  };

  // Initialisation immédiate avec valeurs par défaut
  i18n
    .use(initReactI18next)
    .init({
      resources: {
        en: { translation: {} },
        fr: { translation: {} }
      },
      lng: 'fr',
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false
      },
      react: {
        useSuspense: true
      }
    });

  export default i18n;